var THREE;
try {
  if (window) {
    // THREE
    THREE = require("three");
  }
} catch (e) {}
function Player(id, manager, UTILS, COLORS, config, game, isYTMP) {
  this.biggestY = 0;
  this.id = id;
  this.accid = 0;
  this.isYTMP = isYTMP;
  this.isPlayer = true;
  this.inputs = [];
  this.db = true;
  this.inputDiffs = [];
  this.stateHistory = [];
  this.weaponMeshes = [];
  this.reloads = [];
  this.ammos = [];
  this.tempEggs = [];
  this.tmpStats = {};
  this.sentTo = [];
  this.weaponGeos = {};
  this.objectiveScore = 0;
  this.scoreObjs = {};
  this.checkPoint = null;
  this.checkPointList = [];
  this.convs = 0;
  this.legMeshes = [];
  this.armMeshes = [];
  this.lastInput = {};
  this.lastDeltas = [];
  this.trade = null;
  this.ping = 0;
  // Lag-compensation knobs the client sends in its `ent` packet
  // (src/index.js: ent[11]=lagCompensation, ent[16]=servSendR).
  // Defaults keep getStateConst()/fetchState() finite if a client
  // connects without ever sending these (e.g. bots, replays).
  //   getStateConst()   = ping * 2 * lagComp                (players.js:526)
  //   fetchState() back = ping_const + (1000/cSendRate)*interp (players.js:1803)
  this.lagComp = 1;
  this.cSendRate = 10;
  this.pings = [];
  this.avgSpn = 0;
  this.score = 0;
  this.highestWeaponStreak = {};
  this.weaponStreak = 0;
  this.currentStreakWeapon = null;
  this.deaths = 0;
  this.timer = null;
  this.gameTimer = null;
  this.kills = 0;
  this.sussKills = 0;
  this.weaponKills = {};
  this.driftkills = 0;
  this.closecalls = 0;
  this.classScores = {};
  this.firstblood = 0;
  this.assists = 0;
  this.nukes = 0;
  this.headshots = 0;
  this.quickscopes = 0;
  this.noscopes = 0;
  this.airKills = 0;
  this.turboKills = 0;
  this.melees = 0;
  this.wallbangs = 0;
  this.longshots = 0;
  this.tKnifeKills = 0;
  this.fistKills = 0;
  this.revengeKills = 0;
  this.setbacks = 0;
  this.confirms = 0;
  this.diffuses = 0;
  this.denies = 0;
  this.caps = 0;
  this.deathStreak = 0;
  this.highestStreak = 0;
  this.level = 0;
  this.lives =
    (game.waitTimers &&
      game.config &&
      (game.config.lives || game.mode.lives)) ||
    0;
  this.deltaAdd = 0;
  this.deltaDiv = 1;
  this.sprayIndex = 0;
  this.flagIndex = -1;
  this.meleeIndex = -1;
  this.skinColIndex = -1;
  this.hairCol = -1;
  this.chatCol = -1;
  this.attachIndex = 0;
  this.faceIndex = -1;
  this.hatIndex = -1;
  this.backIndex = -1;
  this.waistIndex = -1;
  this.dyeIndex = -1;
  this.kcStatIndex = -1;
  this.lastSpray = 0;
  this.lastInteract = 0;
  this.lastTerInteract = 0;
  this.lastPicked = {};
  this.playTime = 0;
  this.streaks = {};
  this.deathInfo = {};
  this.ELO = 0;
  this.coughTimer = 0;
  this.noclip = false;
  this.unlimitedAmmo = false;
  this.home = {};
  this.lastLoadout = [];
  this.lastThrow = true;
  this.weaponTier = 0;
  this.inputLock = false;
  this.godMode = false;
  this.kicked = false;
  this.banned = false;
  this.smite = false;
  this.kickedByVote = false;
  this.dmgDealt = 0;
  this.mSent = 0;
  this.didAct = false;
  this.countedPlay = false;
  this.spawned = false;
  this.alias = null;
  this.clanKillsP = 0;
  this.clanDeathsP = 0;
  this.fakeName = null;
  var object;
  var objects;
  var x = [];
  Object.defineProperty(this, "inventory", {
    get() {
      return this._inventory;
    },
    set(value) {
      this._inventory = value;
    },
  });
  // INIT:
  this.init = function (spawnZ, spawnX, spawnY, name, isYou, isHacker) {
    this.active = true;
    this.isYou = isYou;
    this.sfres = !isYou && this.id !== -1;
    this.renderYou = isYou && game.controls.camType.isNormal;
    this.isHacker = isHacker;
    this.y = spawnY;
    this.z = spawnZ;
    this.x = spawnX;
    this.stepSrc = null;
    this.name = name || "unknown";
    this.velX = 0;
    this.velY = 0;
    this.velZ = 0;
    this.xVelC = 0;
    this.zVelC = 0;
    this.walJum = 0;
    this.lastInObj = 0;
    this.renderMinimal = false;
    this.spread = 0;
    this.yaw = 0;
    this.pitch = 0;
    this.height = config.playerHeight;
    this.headScale = config.headScale;
    this.scale = config.playerScale;
    this.stateHistory.length = 0;
    this.aimTime = 0;
    this.spreadPlus = 0;
    this.aimVal = 1;
    this.aimDir = 0;
    this.canSlide = true;
    this.stepVal = 0;
    this.stepChase = 0;
    this.stepDir = 1;
    this.crouchVal = 0;
    this.rampFix = null;
    this.didJump = false;
    this.didJumpW = false;
    this.onGround = true;
    this.onLadder = false;
    this.terrainSlipping = false;
    this.onWall = 0;
    this.jumpTimer = 0;
    this.coverDis = 0;
    this.spinDis = 0;
    this.locked = false;
    this.inputSN = 0;
    this.inputs.length = 0;
    this.inputFreq = 0;
    this.streak = 0;
    this.killStreak = 0;
    this.realKillStreak = 0;
    this.weaponStreak = 0;
    this.currentStreakWeapon = null;
    this.lastKill = 0;
    this.dmgReceived = {};
    this.burstCount = 0;
    this.didShoot = false;
    this.canThrow = true;
    this.airTime = 0;
    this.weaponIndex = 0;
    this.swapTime = 0;
    this.customLoadout = null;
    this.lastPicked = {};
    this.propID = 1;
    this.weaponTier = 0;
    this.isSpectating = false;
    this.lastLoadout.length = 0;
    this.lastThrow = true;
    this.shotCntP = 0;
    this.hitTimer = 0;
    this.ticker = 0;
    this.noMovTimer = 0;
    this.noMovT = 0;
    this.slideTimer = 0;
    this.swapTweenA = 0;
    this.lastInput = {};
    this.landBobY = 0;
    this.landBobYR = 0;
    this.jumpBobY = 0;
    this.leanAnimX = 0;
    this.bobAnimZ = 0;
    this.leanAnimY = 0;
    this.leanAnimZ = 0;
    this.bobAnimY = 0;
    this.idleAnim = 0;
    this.inspecting = false;
    this.inspectAn = {};
    this.inspectX = false;
    this.reward = 0;
    this.recoilAnim = 0;
    this.recoilAnimY = 0;
    this.recoilForce = 0;
    this.stepDirR = 1;
    this.slideLegV = 0;
    this.recoilTweenY = 0;
    this.recoilTweenR = 0;
    this.recoilTweenYM = 0;
    this.recoilTweenZ = 0;
    this.jumpRot = 0;
    this.jumpRotM = 0;
    this.recoilX = 0;
    this.recoilZ = 0;
    this.lodActive = false;
    this.latestData = false;
    this.interpolate = false;
    this.specStream = null;
    this.interProg = 0;
    this.interTick = 0;
    this.lastProg = 0;
    this.makingProg = false;
    this.doingInter = false;
    this.sentTo.length = 0;
    this.deltaAdd = 0;
    this.recon = false;
    this.meleeAnim = {};
    this.inObject = null;
    this.isHidden = false;
    this.isSpectating = false;
    this.kpdData = false;
  };
  this.getName = function (showName, usePremiumAlias, forceReal) {
    if (forceReal || config.isComp || !this.account) {
      return this.name;
    } else if (this.kpdData) {
      return "Officer Buddy";
    } else if (showName) {
      if (this.fakeName) {
        return this.fakeName;
      } else if (usePremiumAlias && this.account && this.account.premiumT > 0) {
        return this.account.alias;
      } else {
        return this.name;
      }
    } else {
      return "Player_" + this.sid;
    }
  };
  // UPDATE LOADOUT:
  this.updateLoadout = function (
    game,
    wepIndex,
    regen = true,
    index,
    secIndex,
    tertiaryIndex,
    utilityIndex,
  ) {
    this.weaponIndex = wepIndex;
    this.reloads.length = 0;
    this.ammos.length = 0;
    this.loadout = [index];
    this.lastThrow = true;
    if (UTILS.isNumber(secIndex)) {
      this.loadout.push(secIndex);
    }
    if (UTILS.isNumber(secIndex)) {
      this.secIndex = secIndex;
    }
    if (UTILS.isNumber(tertiaryIndex)) {
      this.loadout.push(tertiaryIndex);
    }
    if (UTILS.isNumber(utilityIndex)) {
      this.loadout.push(utilityIndex);
    }
    if (this.loadout.indexOf(12) < 0) {
      this.loadout.push(12);
    }
    for (var loadoutIdx = 0; loadoutIdx < this.loadout.length; ++loadoutIdx) {
      this.reloads.push(0);
      this.ammos.push(game.weaponConfig[this.loadout[loadoutIdx]].ammo);
    }
    this.customLoadout = [...this.loadout];
    if (regen && this.active) {
      manager.regenMeshes(this);
    }
  };
  this.refillKnife = function () {
    this.lastThrow = true;
    this.canThrow = true;
    if (this.isYou) {
      for (var loadoutIdx = 0; loadoutIdx < this.ammos.length; ++loadoutIdx) {
        if (game.weaponConfig[this.loadout[loadoutIdx]].melee) {
          var meleeIcon = document.getElementById("weapIconMel");
          if (meleeIcon) {
            meleeIcon.src = UTILS.assetsUrl(
              (this.canThrow &&
              game.weaponConfig[this.loadout[loadoutIdx]].melee
                ? "/textures/melee/icon_" +
                  ((game.store.skins[this.meleeIndex] &&
                    game.store.skins[this.meleeIndex].id) ||
                    0)
                : "/textures/weapons/" +
                  game.weaponConfig[this.loadout[loadoutIdx]].icon) + ".png",
            );
          }
          break;
        }
      }
    }
  };
  // SET CLASS:
  this.setClass = function (gameCtx, classIndex, secIndex, skip) {
    if (!skip) {
      if (gameCtx.config && gameCtx.config.classes.indexOf(classIndex) < 0) {
        if (classIndex != gameCtx.config.classes[0]) {
          this.skins = [-1, -1];
        }
        classIndex = gameCtx.config.classes[0];
      }
      if (gameCtx.mode) {
        if (gameCtx.mode.noWeap) {
          classIndex = 9;
        }
        if (gameCtx.mode.forceClass != null) {
          classIndex = gameCtx.mode.forceClass;
        }
        if (gameCtx.mode.teamClass && gameCtx.mode.teamClass[this.team]) {
          classIndex = gameCtx.mode.teamClass[this.team];
          this.skins = [-1, -1];
        }
      }
    }
    if (classIndex == null || classIndex == null) {
      classIndex = gameCtx.classes.length - 1;
    }
    this.classIndex = classIndex;
    this.loadout = [gameCtx.classes[classIndex].loadout[0]];
    if (!gameCtx.config || !gameCtx.config.noSecondary) {
      if (gameCtx.classes[classIndex].secondary) {
        if (UTILS.isNumber(secIndex)) {
          this.loadout.push(secIndex);
        }
      } else {
        this.secIndex = null;
      }
    }
    if (this.loadout.indexOf(12) < 0) {
      this.loadout.push(12);
    }
    this.speed = gameCtx.classes[classIndex].speed || 1;
    this.resetAmmo();
    this.regenDelay =
      gameCtx.classes[classIndex].regenDelay || config.regenDelay;
    this.maxHealth =
      gameCtx.mode && gameCtx.mode.maxHealth
        ? gameCtx.mode.maxHealth
        : gameCtx.classes[classIndex].health *
          ((gameCtx.config && gameCtx.config.healthMlt) || 1);
    this.meleeLeap = gameCtx.classes[classIndex].leap || 0;
    this.wallJump = gameCtx.classes[classIndex].wallJ || 0;
    this.health = this.maxHealth;
    this.hpChase = 1;
    this.regen =
      (gameCtx.mode && gameCtx.mode.noRegen) ||
      !gameCtx.config ||
      !gameCtx.config.hpRegen
        ? 0
        : gameCtx.classes[classIndex].regen || config.regenVal;
  };
  this.resetAmmo = function (refreshUI) {
    this.reloads.length = 0;
    this.ammos.length = 0;
    this.reloadTimer = 0;
    for (var loadoutIdx = 0; loadoutIdx < this.loadout.length; ++loadoutIdx) {
      this.reloads.push(0);
      this.ammos.push(
        game.weaponConfig[this.loadout[loadoutIdx]].ammo != null &&
          game.mode &&
          game.mode.ammoLimit != null
          ? game.mode.ammoLimit
          : game.weaponConfig[this.loadout[loadoutIdx]].ammo,
      );
    }
    if (refreshUI && this.isYou) {
      manager.updatePlayerAmmo(this);
      manager.resetReloadUIAnim(this);
    }
  };
  this.resetPosition = function (x, y, z, yaw) {
    this.z = z;
    this.x = x;
    this.y = y + 0.01;
    this.yaw = yaw;
    this.velY = 0;
    this.velX = 0;
    this.velZ = 0;
    this.resetAmmo(true);
  };
  // UPDATE:
  this.update = function (game, delta) {
    if (this.active) {
      this.inputs.length;
      if (this.inputs.length) {
        for (var i = 0; i < this.inputs.length; ++i) {
          this.procInputs(this.inputs[i], game, false, !game || game.moveLock);
        }
        this.resetInputs();
      }
      if (this.inputDiffs && this.inputDiffs.length) {
        var now = Date.now();
        for (i = this.inputDiffs.length - 1; i >= 0; --i) {
          if (now - this.inputDiffs[i].t > config.inpBackTim) {
            this.inputDiffs.splice(i, 1);
          }
        }
      }
      this.idleAnim += config.idleAnimS * delta;
      if (this.hpChase > this.health / this.maxHealth) {
        this.hpChase -= delta * 0.0002;
        if (this.hpChase <= 0) {
          this.hpChase = 0;
        }
      } else {
        this.hpChase = this.health / this.maxHealth;
      }
      if (this.interpolate) {
        this.dt += delta;
        var interp = Math.min(
          1.6,
          this.dt / ((1000 / this.sendRateA) * config.interpolation),
        );
        interp /= game.config ? game.config.deltaMlt : 1;
        this.oldX = this.x;
        this.oldY = this.y;
        this.oldZ = this.z;
        this.x = this.x1 + (this.x2 - this.x1) * interp;
        this.y = this.y1 + (this.y2 - this.y1) * interp;
        this.z = this.z1 + (this.z2 - this.z1) * interp;
        if (this.onGround) {
          manager.playerStep(
            this,
            UTILS.distance2D(this.oldX, this.oldZ, this.x, this.z),
          );
        }
        this.yaw = Math.lerpAngle(this.xDir2, this.xDir1, Math.min(1, interp));
        this.pitch = Math.lerpAngle(
          this.yDir2,
          this.yDir1,
          Math.min(1, interp),
        );
      }
    }
  };
  // COLLIDES:
  this.collides = function (other, pad) {
    if (other.collT == "cylinder") {
      if (
        this.y <= other.y + other.height &&
        this.y + this.height >= other.y - other.height
      ) {
        return (
          UTILS.distance2D(this.x, this.z, other.x, other.z) <=
          other.width + this.scale
        );
      } else {
        return undefined;
      }
    } else {
      return (
        this.x - this.scale < other.x + (other.width + (pad || 0)) &&
        this.x + this.scale > other.x - (other.width + (pad || 0)) &&
        this.z - this.scale < other.z + (other.length + (pad || 0)) &&
        this.z + this.scale > other.z - (other.length + (pad || 0)) &&
        this.y <=
          other.y +
            other.height +
            (!other.isBorder || (game.config && game.config.disableB)
              ? 0
              : config.borderH) &&
        this.y + this.height >= other.y - other.height
      );
    }
  };
  this.collidesE = function (other, pad) {
    var width = other.width + (pad || 0);
    var length = other.length + (pad || 0);
    return (
      this.x - this.scale <= other.x + width &&
      this.x + this.scale >= other.x - width &&
      this.z - this.scale <= other.z + length &&
      this.z + this.scale >= other.z - length &&
      this.y <=
        other.y +
          other.height +
          (!other.isBorder || (game.config && game.config.disableB)
            ? 0
            : config.borderH) &&
      this.y + this.height >= other.y - other.height
    );
  };
  this.getStateConst = function () {
    var lc = this.lagComp;
    if (!(lc > 0)) lc = 1;
    return this.ping * 2 * lc;
  };
  // RESET INPUTS:
  this.resetInputs = function () {
    this.inputs.length = 0;
  };
  // RESET PLAYER:
  this.reset = function () {
    this.checkPoint = null;
    this.checkPointList.length = 0;
    this.lastPicked = {};
    this.weaponTier = 0;
    this.customLoadout = null;
    this.lastLoadout.length = 0;
    this.lastThrow = true;
    this.inObject = null;
  };
  // RESET PLAYER ANIM:
  this.resetMeleeAnim = function () {
    this.meleeAnim.weaR = 0;
    this.meleeAnim.weaM = 0;
    this.meleeAnim.armY = 0;
    this.meleeAnim.armR = 0;
    this.meleeAnim.lArm = 0;
    this.meleeAnim.rArm = 0;
    this.meleeAnim.flipW = 0;
    this.meleeAnim.armT = 0;
    this.meleeAnim.armM = 0;
    this.meleeAnim.armE = 0;
    this.meleeAnim.armS = 0;
  };
  let jumpVal = 1;
  // PROCESS INPUT:
  this.procInputs = function (input, game, recon, moveLock) {
    this.recon = recon;
    if (this.noclip) {
      this.onGround = true;
    }
    var delta = Math.max(0, Math.min(input[1], config.dltMx)) / this.deltaDiv;
    this.inputSN = input[0];
    var pitch = (input[3] || 0) / 1000;
    var yaw = (input[2] || 0) / 1000;
    var a7 = UTILS.angleDistance(yaw, this.yaw);
    this.spinDis += Math.abs(a7);
    var a8 = !recon && this.renderYou;
    if (
      a8 &&
      ((this.leanAnimX -= a7 * config.leanSens),
      (this.leanAnimX = UTILS.limit(this.leanAnimX, config.leanMax)),
      (this.leanAnimY -=
        UTILS.angleDistance(pitch, this.pitch) * config.leanSens),
      (this.leanAnimY = UTILS.limit(this.leanAnimY, config.leanMax)),
      this.leanAnimY && (this.leanAnimY *= Math.pow(config.leanPull, delta)),
      this.leanAnimX && (this.leanAnimX *= Math.pow(config.leanPull, delta)),
      this.leanAnimZ && (this.leanAnimZ *= Math.pow(config.leanPullZ, delta)),
      this.bobAnimZ && (this.bobAnimZ *= Math.pow(config.bobPullZ, delta)),
      this.bobAnimY && (this.bobAnimY *= Math.pow(config.bobPullY, delta)),
      this.recoilX && (this.recoilX *= Math.pow(config.leanPull, delta)),
      this.recoilZ && (this.recoilZ *= Math.pow(config.leanPull, delta)),
      this.inspecting && this.weapon)
    ) {
      var a9 = this.weapon.insX || Math.PI / 2.8;
      if (this.inspectX < a9) {
        this.inspectX += (a9 - this.inspectX) * 0.1;
      }
    }
    this.yaw = yaw.round(3);
    this.pitch = pitch.round(3);
    if (this.pitch > Math.PI / 2) {
      this.pitch = Math.PI / 2;
    } else if (this.pitch < -Math.PI / 2) {
      this.pitch = -Math.PI / 2;
    }
    if (input[11] == 4) {
      manager.swapEquipment(this, recon);
    } else if (input[11] == 2) {
      manager.swapMelee(this, recon);
    } else if (input[11] == 1) {
      manager.swapSecondary(this, recon);
    } else if (input[11] == 3) {
      manager.reload(this, null, null, undefined, 0, recon);
    } else if (input[10]) {
      manager.reload(this, input[10], false, undefined, undefined, recon);
    }
    if (!recon) {
      if (this.recoilForce) {
        this.recoilAnim += this.recoilForce * delta;
        this.recoilAnimY +=
          this.recoilForce *
          (this.weapon.recoilY || 1) *
          (1 - this.crouchVal * 0.3) *
          delta;
        this.recoilForce *= Math.pow(this.weapon.recoverF, delta);
      }
      if (this.recoilAnim) {
        this.recoilAnim *= Math.pow(this.weapon.recover, delta);
      }
      if (this.recoilAnimY) {
        this.recoilAnimY *= Math.pow(
          this.weapon.recoverY || this.weapon.recover,
          delta,
        );
      }
    }
    this.oldX = this.x;
    this.oldY = this.y;
    this.oldZ = this.z;
    if (this.weapon.noAim && this.aimVal < 1) {
      if (this.isYou) {
        manager.toggleAim(this, 0);
      }
      this.aimVal = 1;
    } else if (
      this.weapon.zoom &&
      (!game.mode.teamOptions ||
        game.mode.teamOptions[this.team - 1] != "Prop") &&
      (!this.weapon.noAim || this.swapTime > 0)
    ) {
      var aa =
        this.reloadTimer <= 0 &&
        this.swapTime <= 0 &&
        (!this.weapon.melee || this.canThrow) &&
        (game.config.throwMel || !this.weapon.melee);
      if (input[6] && this.aimVal > 0 && aa) {
        manager.cancelInspect(this);
        this.aimDir = 0;
        this.aimVal -= 1 / (this.weapon.aimSpd / delta);
        if (this.aimVal <= 0) {
          this.aimVal = 0;
          if (this.isYou && !recon) {
            manager.toggleAim(this, 1);
          }
        }
        if (this.isYou && !recon && !this.weapon.scope) {
          manager.updateAim(this, 1 - this.aimVal);
        }
      } else if (!aa || (!input[6] && this.aimVal < 1)) {
        this.aimDir = 1;
        if (!this.aimVal && this.isYou && !recon) {
          manager.toggleAim(this, 0);
        }
        this.aimVal += 1 / (this.weapon.aimSpd / delta);
        if (this.aimVal >= 1) {
          this.aimVal = 1;
        }
        if (this.isYou && !recon && !this.weapon.scope) {
          manager.updateAim(this, 1 - this.aimVal);
        }
      }
      if (this.aimVal == 0) {
        this.aimTime += delta;
      } else {
        this.aimTime = 0;
      }
    }
    if (input[8] && this.crouchVal < 1 && !this.onLadder) {
      this.crouchVal += config.crouchSpd * delta;
      if (this.crouchVal >= 1) {
        this.crouchVal = 1;
      }
      if (this.onGround) {
        if (a8) {
          this.bobAnimY -= config.crouchAnim * 1.4 * delta;
        }
      } else {
        this.y += config.crouchSpd * delta;
      }
    } else if (!input[8] && this.crouchVal > 0) {
      this.crouchVal -= config.crouchSpd * delta;
      if (this.crouchVal <= 0) {
        this.crouchVal = 0;
      }
      if (this.onGround) {
        if (a8) {
          this.bobAnimY += config.crouchAnim * delta;
        }
      } else {
        this.y -= config.crouchSpd * delta;
      }
    }
    this.crouchVal &&= this.crouchVal.round(3);
    manager.updateHeight(this);
    var onGroundOrLadder = this.onGround || this.onLadder;
    if (!moveLock) {
      var acceleration;
      acceleration = onGroundOrLadder
        ? (this.terrainSlipping ? config.slippingSpeed : config.playerSpeed) *
          this.speed
        : config.airSpeed *
          game.map.config.arA *
          (game.mode.realMov ? 0.72 : 1);
      acceleration *= this.aimVal ? 1 : config.aimSlow;
      acceleration *= (game.mode.spdMlt && game.mode.spdMlt[this.team]) || 1;
      acceleration *= this.crouchVal ? config.crouchSlow : 1;
      acceleration *= this.weapon.spdMlt * delta;
      var deceleration = 0;
      deceleration = this.onLadder
        ? config.ladderDecel
        : this.terrainSlipping
          ? config.terrainSlipDecel
          : this.onTerrain
            ? config.terrainDecel
            : this.onGround
              ? config.groundDecel
              : config.airDecel;
      if (this.crouchVal <= 0.5) {
        this.canSlide = true;
      }
      if (!this.onGround || !this.crouchVal) {
        this.slideTimer = 0;
      }
      if (this.slideTimer) {
        this.slideTimer -= delta;
        if (this.slideTimer <= 0) {
          this.slideTimer = 0;
        } else {
          acceleration *= 0.25;
          deceleration = this.onTerrain
            ? config.terrainSlideDecel
            : config.slideDecel;
          var vel = UTILS.distance2D(this.velX, this.velZ, 0, 0);
          var ag = this.yaw;
          var dir = UTILS.direction2D(Math.sin(ag), Math.cos(ag), 0, 0);
          if (this.slidCont) {
            this.velX = vel * Math.cos(dir + Math.PI);
            this.velZ = vel * Math.sin(dir + Math.PI);
          } else {
            var ai = UTILS.direction2D(0, 0, this.velX, this.velZ);
            var aj = UTILS.angleDistance(dir, ai) * 0.18;
            this.velX = vel * Math.cos(ai + Math.PI - aj);
            this.velZ = vel * Math.sin(ai + Math.PI - aj);
          }
        }
      }
      this.jumpTimer = Math.max(this.jumpTimer - delta, 0);
      if (
        this.jumpTimer <= 0 &&
        (this.onGround || (game.map.config && game.map.config.infJ))
      ) {
        manager.tryJump(this, input[7]);
      }
      var walljumps = game.config ? game.config.wallJP : 0;
      if (!onGroundOrLadder) {
        var al =
          this.velY < 0 &&
          this.wallJump &&
          this.onWall &&
          walljumps > 0 &&
          this.crouchVal
            ? 0.3
            : 1;
        this.velY -=
          delta *
          (config.gravity * (game.config ? game.config.gravMlt : 1)) *
          al;
      }
      acceleration *= UTILS.limitMM(1 - input[12], 0, 1);
      var am = this.yaw;
      if (game.map.config.camType == 1 || game.map.config.camType == 2) {
        am = 0;
      } else if (game.map.config.camType == 3) {
        am = -Math.PI / 2;
      }
      var moveDirection = config.movDirs[input[4]];
      if (
        moveDirection != Math.PI &&
        moveDirection != 0 &&
        moveDirection != Math.PI / 2 &&
        moveDirection != -Math.PI / 2
      ) {
        acceleration *=
          game.config && !game.mode.realMov ? game.config.strafeSpd : 1;
      }
      if (moveDirection !== undefined) {
        this.velX += acceleration * Math.cos(moveDirection - am);
        this.velZ += acceleration * Math.sin(moveDirection - am);
        if (this.noclip) {
          this.velY +=
            acceleration * (this.pitch * (moveDirection > 0 ? -1 : 1));
        }
      }
      if (!onGroundOrLadder && a7 && game.config.airStrf) {
        vel = UTILS.distance2D(this.velX, this.velZ, 0, 0);
        ai = UTILS.direction2D(0, 0, this.velX, this.velZ) + a7 * 0.73;
        if ((input[4] == 3 && a7 > 0) || (input[4] == 7 && a7 < 0)) {
          this.velX = vel * Math.cos(ai + Math.PI);
          this.velZ = vel * Math.sin(ai + Math.PI);
        }
      }
      if (!onGroundOrLadder) {
        if (this.xVelC) {
          this.velX += this.xVelC * 0.07;
          this.xVelC = 0;
        }
        if (this.zVelC) {
          this.velZ += this.zVelC * 0.07;
          this.zVelC = 0;
        }
      }
      if (this.velX) {
        this.x += this.velX * game.map.config.speedX * delta;
        this.velX *= Math.pow(deceleration, delta);
        this.velX = UTILS.cropVal(this.velX, config.decelMin);
      }
      if (this.velY) {
        this.y += this.velY * game.map.config.speedY * delta;
        if (this.noclip) {
          this.velY *= Math.pow(deceleration, delta);
        } else if (this.velY > 0) {
          this.velY -= delta * 0.000032;
        } else if (this.velY <= -0.3) {
          this.velY = -0.3;
        }
      }
      if (this.velZ) {
        this.z += this.velZ * game.map.config.speedZ * delta;
        this.velZ *= Math.pow(deceleration, delta);
        this.velZ = UTILS.cropVal(this.velZ, config.decelMin);
      }
      if (!recon) {
        if (this.velX || this.velY || this.velZ) {
          this.noMovT = 0;
        } else {
          this.noMovT += delta;
        }
        var ao =
          (game.mode.teamOptions &&
            game.mode.teamOptions[this.team - 1] == "Stalker" &&
            this.noMovT >= 300) ||
          this.forceHide;
        if (this.isHidden != ao) {
          this.isHidden = ao;
          if (this.isYou) {
            hiddenMsg.style.display = this.isHidden ? "block" : "none";
          }
        }
      }
      if (
        input[5] &&
        game.mode.teamOptions &&
        game.mode.teamOptions[this.team - 1] == "Prop"
      ) {
        manager.pickProp(this);
      }
      if (!input[5] && !recon) {
        this.doingInter = false;
      }
      var canJump = this.onGround && !this.didJump;
      var aq = false;
      var maxCollsionHeight = null;
      this.onGround = this.noclip || false;
      this.onWall = 0;
      this.onLadder = false;
      this.makingProg = false;
      manager.clearInteract(this);
      objects = game.map.manager.getGridArrays(this.x, this.y, this.z);
      if (!this.noclip && objects) {
        x.length = 0;
        for (var i = 0; i < objects.length; ++i) {
          object = objects[i];
          if (!(x.indexOf(object.sid) >= 0)) {
            x.push(object.sid);
            if (
              (object.gate || object.bank || object.terminal) &&
              (object.active || (!object.active && object.closeable)) &&
              object.tRadius &&
              this.collides(object, object.tRadius || 0) &&
              (!object.team ||
                !game.mode ||
                !game.mode.teams ||
                object.team == this.team)
            ) {
              if (object.gate) {
                if (!object.noMsg) {
                  manager.changeInteract(this, 0, object);
                }
              } else if (object.bank) {
                manager.changeInteract(this, 1, object);
              } else if (object.terminal && !object.noMsg) {
                manager.changeInteract(this, 2);
              }
            }
            if (object.active && this.collidesE(object, config.collPad)) {
              if (
                object.onCollision &&
                game.now - (object.lastColT || 0) >= object.onColT
              ) {
                object.lastColT = game.now;
                game.onTrigger(this, object);
              }
              if (object.onInteract) {
                manager.changeInteract(this, 4, null, 1);
                if (input[5] && this.onGround) {
                  this.doingInter = true;
                  this.makingProg = true;
                  this.interProg += delta / object.onInteractT;
                  if (this.interProg >= 1) {
                    this.interProg = 0;
                    game.onTrigger(this, object);
                  }
                }
              } else if (object.onEnter) {
                if (this.inObject != object.sid) {
                  game.onTrigger(this, object);
                }
                this.inObject = object.sid;
              } else if (object.isEvent);
              else if (object.jumpPad) {
                var at =
                  (object.bounce * 0.1) /
                  (this.crouchVal == 1 && object.crouch ? 2 : 1);
                this.velY = at;
                this.onGround = false;
                if (!recon && this.isYou) {
                  SOUND.play("bounce_0", 1, false, UTILS.randFloat(0.95, 1));
                }
              } else if (object.score) {
                if (!this.scoreObjs[object.sid]) {
                  this.scoreObjs[object.sid] = 1;
                  manager.score(this, object.scoreP);
                }
              } else if (
                object.premium &&
                ((this.account && this.account.premiumT) || this.premiumT)
              );
              else if (
                object.verified &&
                ((this.account && this.account.featured) || this.featured)
              );
              else if (
                !object.teamZ ||
                (object.team &&
                  game.mode &&
                  game.mode.teams &&
                  object.team != this.team)
              ) {
                if (object.teleporter) {
                  game.checkTeleport(this, object);
                } else if (object.checkpoint) {
                  game.setCheckPoint(this, object);
                } else if (
                  !UTILS.isNumber(object.pickup) ||
                  (game.mode.teamOptions &&
                    game.mode.teamOptions[this.team - 1] == "Infected")
                ) {
                  if (object.flag);
                  else if (object.trigger) {
                    if (
                      this.flag &&
                      object.team == this.team &&
                      object.flagObj &&
                      !object.flagObj.carrier &&
                      object.flagObj.x == object.flagObj.orgX &&
                      object.flagObj.y == object.flagObj.orgY &&
                      object.flagObj.z == object.flagObj.orgZ
                    ) {
                      game.capFlag(this, this.flag);
                    }
                  } else if (object.kill) {
                    if (this.flag) {
                      game.resetFlag(this.flag);
                      this.flag = null;
                    }
                    if (manager.hasServer && !this.godMode) {
                      manager.kill(this);
                    }
                  } else if (object.ladder) {
                    if (
                      this.y < object.y + object.height &&
                      this.crouchVal == 0 &&
                      ((this.velY = 0),
                      (this.onLadder = true),
                      (this.onTerrain = false),
                      (this.stepSrc = null),
                      moveDirection !== undefined)
                    ) {
                      if (
                        (ay =
                          (Math.abs(
                            UTILS.angleDistance(
                              object.dir,
                              moveDirection - this.yaw,
                            ),
                          ) -
                            Math.PI / 2) /
                          (Math.PI / 2)) > 0
                      ) {
                        this.y +=
                          config.ladderSpeed *
                          game.map.config.ldA *
                          this.weapon.spdMlt *
                          delta *
                          ay;
                        if (this.y <= object.y - object.height) {
                          this.y = object.y - object.height;
                        } else if (this.y >= object.y + object.height) {
                          this.y = object.y + object.height;
                        }
                      }
                    }
                  } else {
                    if (
                      !object.ramp &&
                      object.collT != "cylinder" &&
                      !canJump &&
                      this.y < object.y + object.height &&
                      object.y + object.height - this.y > config.climbHeight &&
                      object.wallJumpable
                    ) {
                      if (
                        this.oldX - this.scale >=
                        object.x + object.width - config.collPad
                      ) {
                        this.onWall = 1;
                      } else if (
                        this.oldX + this.scale <=
                        object.x - object.width + config.collPad
                      ) {
                        this.onWall = 2;
                      } else if (
                        this.oldZ - this.scale >=
                        object.z + object.length - config.collPad
                      ) {
                        this.onWall = 3;
                      } else if (
                        this.oldZ + this.scale <=
                        object.z - object.length + config.collPad
                      ) {
                        this.onWall = 4;
                      }
                    }
                    if (!this.collides(object)) {
                      continue;
                    }
                    if (object.ramp) {
                      if (this.y < object.y + object.height) {
                        var progress = Math.max(
                          0,
                          Math.min(
                            1,
                            UTILS.progressOnLine(
                              object.ramp.sX,
                              object.ramp.sZ,
                              object.ramp.eX,
                              object.ramp.eZ,
                              this.x + this.scale * Math.cos(object.dir),
                              this.z + this.scale * Math.sin(object.dir),
                            ),
                          ),
                        );
                        var collisionHeight =
                          object.y -
                          object.height +
                          (object.height * 2 + 0.01) * progress;
                        if (maxCollsionHeight === null) {
                          maxCollsionHeight = collisionHeight;
                        }
                        if (
                          (this.y <= collisionHeight || canJump) &&
                          maxCollsionHeight <= collisionHeight
                        ) {
                          maxCollsionHeight = collisionHeight;
                          if (object.boost) {
                            this.y = collisionHeight;
                            var aw = object.boost * config.boosterSpd * delta;
                            this.velX +=
                              aw *
                              Math.sin(-object.dir + Math.PI / 2) *
                              Math.cos(object.boostDr);
                            this.velZ +=
                              aw *
                              Math.cos(-object.dir + Math.PI / 2) *
                              Math.cos(object.boostDr);
                            this.velY += aw * Math.sin(object.boostDr);
                          } else {
                            if (this.oldY > this.y) {
                              manager.resetStep(this, recon);
                            }
                            this.y = collisionHeight;
                            this.velY = 0;
                            this.onWall = 0;
                            this.onGround = true;
                            this.onTerrain = false;
                            aq = true;
                            this.rampFix =
                              object.y -
                              object.height +
                              object.height * 2 * Math.round(progress);
                          }
                        }
                      }
                    } else if (object.collT == "cylinder") {
                      var ax = false;
                      if (this.oldY >= object.y + object.height) {
                        if (this.oldY > this.y) {
                          manager.resetStep(this, recon);
                        }
                        this.y = object.y + object.height;
                        this.velY = 0;
                        this.onGround = true;
                        this.onTerrain = false;
                        ax = true;
                      } else if (
                        this.oldY + this.height <=
                        object.y - object.height
                      ) {
                        this.y = object.y - object.height - this.height;
                        this.velY = 0;
                      } else if (
                        this.y < object.y + object.height &&
                        object.y + object.height - this.y <=
                          config.climbHeight &&
                        this.oldY < object.y + object.height &&
                        canJump
                      ) {
                        this.y +=
                          (object.y + object.height - this.y) * 0.3 +
                          (config.isComp ? 0.00001 : 0);
                        this.onGround = true;
                        this.onTerrain = false;
                        ax = true;
                      } else {
                        var ay = UTILS.direction2D(
                          this.x,
                          this.z,
                          object.x,
                          object.z,
                        );
                        this.x =
                          object.x + (object.width + this.scale) * Math.cos(ay);
                        this.z =
                          object.z + (object.width + this.scale) * Math.sin(ay);
                      }
                      if (ax) {
                        var ay =
                          UTILS.direction2D(
                            this.x,
                            this.z,
                            object.x,
                            object.z,
                          ) -
                          (object.spin || 0) * delta * config.diskSpin;
                        var az = UTILS.distance2D(
                          this.x,
                          this.z,
                          object.x,
                          object.z,
                        );
                        var aA = this.x;
                        var aB = this.z;
                        this.x = object.x + az * Math.cos(ay);
                        this.z = object.z + az * Math.sin(ay);
                        this.xVelC = this.x - aA;
                        this.zVelC = this.z - aB;
                      }
                    } else if (
                      (!object.isBorder ||
                        (game.config && game.config.disableB)) &&
                      this.y < object.y + object.height &&
                      object.y + object.height - this.y <= config.climbHeight &&
                      this.oldY < object.y + object.height &&
                      canJump
                    ) {
                      this.y += delta * 0.03;
                      if (this.y > object.y + object.height) {
                        this.y = object.y + object.height;
                      }
                      this.onGround = true;
                      this.onTerrain = false;
                    } else if (
                      this.oldY >=
                      object.y +
                        object.height +
                        (!object.isBorder ||
                        (game.config && game.config.disableB)
                          ? 0
                          : config.borderH)
                    ) {
                      this.stepSrc = object.stepSrc;
                      if (this.oldY > this.y) {
                        manager.resetStep(this, recon);
                      }
                      this.y =
                        object.y +
                        object.height +
                        (!object.isBorder ||
                        (game.config && game.config.disableB)
                          ? 0
                          : config.borderH);
                      this.velY = 0;
                      this.onGround = true;
                      this.onTerrain = false;
                    } else if (
                      this.oldX - this.scale >=
                      object.x + object.width - 0.00001
                    ) {
                      this.x = object.x + object.width + this.scale;
                      this.velX = 0;
                    } else if (
                      this.oldX + this.scale <=
                      object.x - object.width + 0.00001
                    ) {
                      this.x = object.x - object.width - this.scale;
                      this.velX = 0;
                    } else if (
                      this.oldZ - this.scale >=
                      object.z + object.length - 0.00001
                    ) {
                      this.z = object.z + object.length + this.scale;
                      this.velZ = 0;
                    } else if (
                      this.oldZ + this.scale <=
                      object.z - object.length + 0.00001
                    ) {
                      this.z = object.z - object.length - this.scale;
                      this.velZ = 0;
                    } else if (
                      this.oldY + this.height <=
                      object.y - object.height
                    ) {
                      this.y = object.y - object.height - this.height;
                      this.velY = 0;
                    }
                  }
                } else {
                }
              } else {
              }
            } else if (object.sid == this.inObject) {
              this.inObject = null;
            }
          }
        }
        if (game.mode && game.mode.site) {
          for (i = 0; i < game.map.manager.sites.length; ++i) {
            object = game.map.manager.sites[i];
            if (!recon && this.collides(object)) {
              if (this.team == 2 && this.weapon && this.weapon.bomb) {
                if (input[5] && this.onGround) {
                  this.doingInter = true;
                  this.interTick -= delta;
                  if (this.isYou && this.interTick <= 0) {
                    this.interTick = 400;
                    SOUND.play("beep_0", 0.1, false, UTILS.randFloat(0.95, 1));
                  }
                  this.interProg += delta / 2000;
                  this.makingProg = true;
                  if (this.interProg >= 1) {
                    this.interProg = 1;
                    game.plantBomb(this, object);
                  }
                } else {
                  manager.changeInteract(this, 3, 1, 1);
                }
              } else if (this.team == 2 && this.loadout.indexOf(17) > -1) {
                manager.changeInteract(this, 3, 2, 1);
              }
            }
          }
        }
        if (game.mode && game.mode.flags) {
          for (i = 0; i < game.map.manager.flags.length; ++i) {
            if (
              (object = game.map.manager.flags[i]).active &&
              this.collides(object) &&
              object.flag
            ) {
              game.pickupFlag(this, object);
            }
          }
        }
        for (var aC in game.map.manager.spawnables) {
          if (
            (object = game.map.manager.spawnables[aC]).active &&
            this.collides(object)
          ) {
            game.pickupSpawnable(this, object);
          }
        }
        if (!game.mode || !game.mode.noPickups) {
          for (i = 0; i < game.map.manager.pickups.length; ++i) {
            object = game.map.manager.pickups[i];
            if (
              this.collides(object) &&
              UTILS.isNumber(object.pickup) &&
              (!game.mode.teamOptions ||
                game.mode.teamOptions[this.team - 1] != "Infected")
            ) {
              if (
                !object.active ||
                (object.team &&
                  game.mode &&
                  game.mode.teams &&
                  object.team != this.team) ||
                (game.weaponConfig[object.pickup].type == 3 &&
                  (!game.mode || !game.mode.site))
              ) {
                if (
                  !object.active &&
                  this.team == 1 &&
                  game.weaponConfig[object.pickup].type == 3 &&
                  game.mode &&
                  game.mode.site
                ) {
                  if (input[5] && this.onGround) {
                    this.doingInter = true;
                    this.interProg += delta / 4000;
                    this.makingProg = true;
                    if (this.interProg >= 1) {
                      this.interProg = 1;
                      game.diffuseBomb(this);
                    }
                  } else {
                    manager.changeInteract(this, 3, 3, 1);
                  }
                }
              } else if (!object.noMsg) {
                manager.changeInteract(this, 6, object);
              }
            }
          }
        }
      }
      if (
        !this.didJump &&
        this.rampFix != null &&
        Math.abs(this.y - this.rampFix) <= config.climbHeight
      ) {
        if (!aq) {
          this.y = this.rampFix;
          this.onGround = true;
          this.velY = 0;
          this.rampFix = null;
        }
      } else {
        this.rampFix = null;
      }
      if (!this.makingProg && !recon) {
        this.interProg = 0;
      }
      var terrain = game.map.terrain;
      if (terrain && !this.noclip) {
        var aE = terrain.raycast(this.x, -this.z, 10000, 0, 0, -20000, true);
        if (aE) {
          var aF = aE.z;
          if (this.y <= aF) {
            if (this.oldY > this.y) {
              manager.resetStep(this, recon);
            }
            this.onTerrain = true;
          }
          if (this.onTerrain) {
            this.onGround = true;
            var aG = terrain._raycastNormal;
            aG.set(aG.x, aG.z, -aG.y);
            this.y = aF;
            var aH = aG.x;
            var aI = -1 + aG.y;
            var aJ = aG.z;
            var aK = Math.sqrt(aH * aH + aI * aI + aJ * aJ);
            this.terrainSlipping = aK > config.terrainSlideThreshold;
            this.terrainSlipping = false;
            if (this.terrainSlipping) {
              aK *=
                config.gravity *
                (game.config ? game.config.gravMlt : 1) *
                config.terrainGravityMlt *
                delta;
              this.velX += aH * aK;
              this.velY += aI * aK;
              this.velZ += aJ * aK;
            } else {
              this.velY = 0;
              this.jumpTimer = 0;
            }
          }
        }
        if (!this.onTerrain) {
          this.terrainSlipping = false;
        }
      }
      if (this.onGround) {
        this.airTime = 0;
      } else {
        this.airTime += delta;
      }
    }
    this.coverDis += UTILS.distance2D(this.oldX, this.oldZ, this.x, this.z);
    if (
      !recon &&
      (!game.mode.teamOptions ||
        game.mode.teamOptions[this.team - 1] != "Prop") &&
      (!game.map.config || game.map.config.mdl !== 1)
    ) {
      var aL = UTILS.getD3D(
        this.oldX,
        this.oldY,
        this.oldZ,
        this.x,
        this.y,
        this.z,
      );
      if (this.renderYou) {
        if (this.onLadder) {
          aL *= 1.4;
        }
        UTILS.direction2D(this.oldX, this.oldZ, this.x, this.z);
        this.bobAnimZ +=
          UTILS.distance2D(this.oldX, this.oldZ, this.x, this.z) *
          config.bobMltZ;
        this.bobAnimY -= (this.oldY - this.y) * config.bobMltY;
      }
      if (this.isYou && onGroundOrLadder && moveDirection !== undefined) {
        manager.playerStep(this, aL);
      }
      if (this.renderYou) {
        if (onGroundOrLadder && moveDirection !== undefined) {
          this.leanAnimZ -=
            aL *
            config.leanMltZ *
            (this.weapon.zLnM || 1) *
            Math.cos(moveDirection);
        } else {
          this.stepVal *= Math.pow(config.stepPull, delta);
        }
        if (this.stepChase != this.stepVal) {
          this.stepChase += (this.stepVal - this.stepChase) * 0.15;
        }
      }
      this.spreadPlus +=
        (aL * config.spreadMove +
          Math.abs(this.oldY - this.y) * config.spreadFall) *
        (this.weapon.movSpread || 1);
      this.spreadPlus *= Math.pow(config.spreadRecover, delta);
      this.spread = this.weapon.noSpread
        ? 0
        : Math.max(
            this.weapon.minSpread || 0,
            (this.weapon.spread -
              this.weapon.spread * config.crouchSpread * this.crouchVal +
              this.recoilAnim * config.spreadMlt +
              this.spreadPlus) *
              this.aimVal,
          );
      var aM = !game.mode || !game.mode.noReloads;
      if (input[9] && aM) {
        manager.startReload(this);
      }
      if (this.reloadTimer > 0) {
        var aN = this.reloadTimer;
        this.reloadTimer -= delta;
        manager.reloadUIAnim(this);
        if (
          this.isYou &&
          aN >= (this.weapon.reload * (game.config.reSpd || 1)) / 2 &&
          this.reloadTimer < (this.weapon.reload * (game.config.reSpd || 1)) / 2
        ) {
          manager.endReload(this.weapon);
        }
        if (this.reloadTimer <= 0) {
          this.reloadTimer = 0;
          this.didShoot = false;
          this.ammos[this.weaponIndex] = this.weapon.ammo;
          manager.updatePlayerAmmo(this);
          manager.resetReloadUIAnim(this);
        }
      }
      if (this.swapTime > 0) {
        this.swapTime -= delta;
        if (this.swapTime < 0) {
          this.swapTime = 0;
        }
      }
      for (i = 0; i < this.reloads.length; ++i) {
        if (this.reloads[i] > 0) {
          this.reloads[i] -= delta;
          if (this.reloads[i] < 0) {
            this.reloads[i] = 0;
          }
        }
      }
      if (this.weapon && !moveLock && !this.doingInter) {
        var aO = this.burstCount || (!this.weapon.nAuto && input[5]);
        if (this.didShoot && !input[5]) {
          this.didShoot = false;
        }
        if (!this.didShoot && input[5]) {
          aO = true;
        }
        if (
          aO &&
          this.reloads[this.weaponIndex] <= 0 &&
          this.swapTime <= 0 &&
          this.reloadTimer <= 0
        ) {
          this.noMovTimer = 0;
          if (this.weapon.melee) {
            manager.melee(this);
          } else {
            var aP = parseInt(this.weapon.id);
            if (this.ammos[this.weaponIndex] > 0) {
              manager.shoot(this, input, aP);
            } else if (aM) {
              manager.startReload(this);
            }
          }
        }
      }
    }
    if (!moveLock && recon && input.velObj) {
      this.velX -= input.velObj.x;
      this.velZ -= input.velObj.y;
      if (!this.noclip) {
        this.velY -= input.velObj.z;
      }
      this.onGround = false;
    }
    if (
      this.wallJump &&
      !this.onGround &&
      !this.onLadder &&
      this.onWall &&
      walljumps > 0 &&
      !moveLock &&
      (this.didJumpW && !input[7] && (this.didJumpW = false),
      !this.didJumpW && input[7])
    ) {
      this.didJumpW = true;
      if (!recon && this.isYou) {
        if (this.jumpTween) {
          this.jumpTween.stop();
        }
        this.jumpTween = new TWEEN.Tween(this)
          .to(
            {
              jumpBobY: 0.26,
            },
            500,
          )
          .easing(TWEEN.Easing.Back.Out)
          .start();
        new TWEEN.Tween(this)
          .to(
            {
              jumpRot: [0.15, 0],
            },
            900,
          )
          .easing(TWEEN.Easing.Back.Out)
          .start();
        SOUND.play("jump_" + UTILS.randInt(0, 1), 0.04, false);
      }
      var aQ = (game.mode.realMov ? 0.7 : 1) * 0.03;
      this.velY = (game.mode.realMov ? 0.9 : 1) * 0.058;
      if (this.onWall == 1) {
        this.velX = aQ * walljumps;
      } else if (this.onWall == 2) {
        this.velX = -aQ * walljumps;
      } else if (this.onWall == 3) {
        this.velZ = aQ * walljumps;
      } else if (this.onWall == 4) {
        this.velZ = -aQ * walljumps;
      }
      this.onWall = 0;
    }
    if (!moveLock && game.mode.canTrade && !game.waitTimers) {
      var aR = this.x;
      var aS = this.y;
      var aT = this.z;
      if (game.now - 0 >= 200) {
        for (i = 0; i < game.players.list.length; ++i) {
          object = game.players.list[i];
          if (this.active && object.active && !object.isYou) {
            var aU = config.playerHeight / 2;
            if (
              UTILS.getD3D(
                aR,
                aS + aU,
                aT,
                object.x,
                object.y + aU,
                object.z,
              ) <=
              aU * 2.4
            ) {
              manager.changeInteract(this, 5, object, 1);
            }
          }
        }
      }
    }
    if (!moveLock) {
      manager.playerCollisions(this);
      manager.updateInteract(this);
    }
  };
}
module.exports.Player = Player;
// PLAYER MANAGER:
module.exports.manager = function (
  game,
  RENDER,
  SOUND,
  PARTICLES,
  UTILS,
  COLORS,
  prefabs,
  config,
  IO,
) {
  this.list = [];
  var F;
  var G;
  var H;
  var I = {};
  var J = require("./kills.js");
  this.hasServer = IO ? 1 : 0;
  // PLAYER COLLISIONS:
  this.playerCollisions = function (player) {
    if (IO && !game.waitTimers && game.mode.convTeam) {
      for (var i = 0; i < this.list.length; ++i) {
        if (
          player.active &&
          this.list[i].active &&
          player.team == game.mode.convTeam &&
          player.team != this.list[i].team &&
          !this.list[i].godMode
        ) {
          var halfHeight = config.playerHeight / 2;
          if (
            UTILS.getD3D(
              player.x,
              player.y + halfHeight,
              player.z,
              this.list[i].x,
              this.list[i].y + halfHeight,
              this.list[i].z,
            ) <=
            halfHeight * 2.4
          ) {
            window.IO.broadcast(
              "game" + game.sid,
              "ac",
              player.sid,
              this.list[i].sid,
              game.mode.convWord,
            );
            this.score(player, 100);
            player.convs++;
            game.updateTeam(this.list[i], player.team);
            if (game.mode.killConv) {
              this.kill(this.list[i], null, null, true);
            }
            if (game.gameTimer) {
              game.gameTimer += 10000;
            }
          }
        }
      }
    }
  };
  // UPDATE:
  this.update = function (P) {
    for (var Q = 0; Q < this.list.length; ++Q) {
      if (this.list[Q].active) {
        this.list[Q].update(game, P);
        if (IO) {
          if (
            game &&
            game.isCustom &&
            this.list[Q].playTime >= 30000 &&
            this.list[Q].didAct
          ) {
            game.playTime += P;
            game.uniquePlay(this.list[Q]);
          }
          this.tickPlayer(this.list[Q], P);
          this.storeState(this.list[Q]);
          if (this.list[Q].y <= game.map.deathY) {
            if (this.list[Q].flag) {
              game.resetFlag(this.list[Q].flag);
              this.list[Q].flag = null;
            }
            this.kill(this.list[Q]);
          }
        }
        if (RENDER) {
          this.updateMsh(this.list[Q]);
          this.updateHeight(this.list[Q]);
        }
      } else if (this.list[Q].deathInfo && this.list[Q].deathInfo.tillNext) {
        this.list[Q].deathInfo.tillNext -= P;
        if (this.list[Q].deathInfo.tillNext <= 0) {
          this.list[Q].deathInfo.tillNext = null;
          IO.send(this.list[Q].id, "frs");
        }
      }
    }
  };
  // SET TEAM:
  this.setTeam = function (player) {
    if (game.config.isFromQueue) {
      if (player.tmpAccountName) {
        player.team = game.getAccountTeamIndex(player.tmpAccountName) + 1;
        if (player.team == -1) {
          console.warn("Could not find team index");
        }
      } else {
        console.warn("Player should have account");
        player.team = -1;
      }
    } else if (!game.waitTimers && game.mode.convTeam) {
      player.team = game.mode.convTeam;
    } else if (game.mode.teamOptions && !game.mode.teamSort) {
      player.team = 1;
    } else if (game.mode.friendly) {
      player.team = 1;
    } else if (game.mode.clanWar) {
      player.team =
        player.account && player.account.clan ? player.account.clan : 1;
    } else if (!player.team && game.mode.teams && !player.spectating) {
      var teamOneCount = 0;
      var teamTwoCount = 0;
      for (var i = 0; i < this.list.length; ++i) {
        if (!this.list[i].spectating) {
          if (this.list[i].team == 1) {
            teamOneCount++;
          }
          if (this.list[i].team == 2) {
            teamTwoCount++;
          }
        }
      }
      player.team = teamOneCount >= teamTwoCount ? 2 : 1;
    }
  };
  // GET ACTIVE COUNT:
  this.activeCount = function () {
    var count = 0;
    for (var i = 0; i < this.list.length; ++i) {
      if (this.list[i].active) {
        count++;
      }
    }
    return count;
  };
  // FORCE POSITION:
  this.forcePos = function () {
    for (var i = 0; i < this.list.length; ++i) {
      this.list[i].forcePos = true;
      if (this.list[i].objInstances) {
        this.list[i].objInstances.visible = false;
        this.list[i].isSpectating = false;
      }
    }
  };
  // STORE STATE:
  this.storeState = function (player) {
    player.stateHistory.unshift({
      time: game.now,
      h: player.height,
      x: player.x,
      y: player.y,
      z: player.z,
    });
    for (var i = player.stateHistory.length - 1; i >= 0; --i) {
      if (game.now - player.stateHistory[i].time >= config.stateHistory) {
        player.stateHistory.splice(i, 1);
      }
    }
  };
  // FETCH STATE:
  this.fetchState = function (player, ping) {
    var sendRate = player.cSendRate;
    if (!(sendRate > 0)) sendRate = 10;
    var targetTime =
      game.now - (ping + (1000 / sendRate) * config.interpolation);
    for (var i = 0; i < player.stateHistory.length; ++i) {
      if (player.stateHistory[i].time <= targetTime) {
        return player.stateHistory[i];
      }
    }
    return player.stateHistory[player.stateHistory.length - 1];
  };
  // UPDATE HEIGHT:
  this.updateHeight = function (player) {
    var Q =
      game.config.thirdPerson ||
      (game.map.config &&
        (game.map.config.camOffX ||
          game.map.config.camOffY ||
          game.map.config.camOffZ));
    var R = config.crouchDst * player.crouchVal;
    if (!RENDER || (player.renderYou && !Q)) {
      player.height = config.playerHeight - R;
    } else {
      var S = config.crouchLean * player.crouchVal;
      RENDER.rotateMesh(player.lowerBody, 0, S + player.pitch * 0.5, 0);
      if (player.upperBody) {
        player.upperBody.rotation.x -= S;
      }
      RENDER.moveMesh(player.lowerBody, 0, config.legHeight - R, 0);
      for (var T = 0; T < 4; ++T) {
        if (player.legMeshes[T] && !RENDER.lowSpec) {
          player.legMeshes[T].visible = T <= 1 ? !player.crouchVal : !!player.crouchVal;
        }
      }
    }
  };
  // UPDATE PLAYER MESH:
  this.updateMsh = function (player, X) {
    if (player.objInstances) {
      var Y =
        game.config.thirdPerson ||
        !game.controls ||
        !game.controls.camType.isNormal ||
        (game.map.config &&
          (game.map.config.camOffX ||
            game.map.config.camOffY ||
            game.map.config.camOffZ));
      var Z = RENDER.aimAnim && player.isYou ? player.aimVal : 1;
      var a0 = player.weapon.animWhileAim ? 1 : Z;
      var a1 =
        (1 - (1 - config.aimAnimMlt) * (1 - Z)) *
        config.animMult *
        RENDER.weaponBob;
      var a2 = 1 - player.crouchVal * 0.8;
      var a3 = (1 - (1 - Z)) * config.animMult;
      var a4 = (1 - (1 - Z) * (player.weapon.recoilYMA || 1)) * config.animMult;
      if (!player.renderYou) {
        a3 = 0;
      }
      var a5 = 1 - (player.weapon.recoilZM || 0.5) * (1 - a0);
      var a6 =
        (1 - (player.weapon.zRot || 0.3) * (1 - a0)) *
        (player.weapon.zRM || 1) *
        RENDER.weaponBob;
      var a7 = 1 - (player.weapon.jYMlt || 1) * (1 - a0);
      var a8 = 1 - (1 - a0) * 0.45;
      var a9 = player.bobAnimY * 0.9 * a7 * RENDER.weaponBob * a3;
      var aa =
        player.landBobY *
        (player.weapon.landBob || 1) *
        0.6 *
        (1 - (1 - a0) * 0.75) *
        RENDER.weaponBob;
      if (player.landBobYR != aa) {
        player.landBobYR += (aa - player.landBobYR) * 0.1;
      }
      var ab = player.landBobY * (player.weapon.landBob || 1) * 0.1;
      var ac = 1 - player.crouchVal * 0.5;
      player.crouchVal;
      var ad = player.jumpRot * ac * a3 * RENDER.weaponBob;
      if (player.jumpRotM != ad) {
        player.jumpRotM += (ad - player.jumpRotM) * 0.08;
      }
      var ae = player.jumpBobY * (player.weapon.jumpYM || 1) * a3 * ac * RENDER.weaponBob;
      var af = 1 - (1 - a0) * 0.75;
      var ag = 1 - (player.weapon.aimRecMlt || 1) * (1 - a0);
      var ah = X ? 0.05 : config.stepAnim;
      var ai = Math.sin(player.stepVal) * ah;
      var aj = (Math.cos(player.stepVal * 2) / 2) * ah;
      var ak = -Math.sin(player.stepChase) * ah;
      var al = (-Math.cos(player.stepChase * 2) / 2) * ah;
      var am = Y ? 0 : 1 - Z;
      var an = (am <= 0.5 ? am : 0.5 - (am - 0.5)) * (player.weapon.aimLean || 0.5);
      var ao = player.swapTime / player.weapon.swapTime;
      var ap = player.leftHand ? -1 : 1;
      var aq = player.weapon.xOff * (player.renderYou ? RENDER.weaponOffX : 1) * ap;
      var ar = player.weapon.yOff * (player.renderYou ? RENDER.weaponOffY : 1);
      var as = player.weapon.zOff * (player.renderYou ? RENDER.weaponOffZ : 1);
      var at = 0;
      if (player.reloadTimer > 0) {
        at =
          (at =
            1 - player.reloadTimer / (player.weapon.reload * (game.config.reSpd || 1))) >
          0.5
            ? 0.5 - (at - 0.5)
            : at;
      }
      at *= player.renderYou ? 1 : 0.3;
      var au = (1 - (1 - Z) * 0.88) * 1.75 * RENDER.weaponBob;
      var av = player.renderYou && !Y ? Math.abs(ak * 0.5) * a3 : Math.abs(ai * 3.5);
      if (player.isYou || player.id == -1 || player.db) {
        RENDER.moveMesh(player.objInstances, player.x, player.y + av, player.z);
      }
      var aw = player.renderYou ? (Y ? -ai * 0.5 : 0) : -ai * 2;
      if (game.map.config && game.map.config.mdl == 2) {
        aw = 0;
      }
      if (
        (!game.mode ||
          !game.mode.teamOptions ||
          game.mode.teamOptions[player.team - 1] != "Prop") &&
        (!game.map.config || game.map.config.mdl != 1)
      ) {
        RENDER.rotateMesh(player.objInstances, player.yaw + aw);
      }
      aj -= aj * (player.crouchVal * config.crouchAnimMlt);
      ai -= ai * (player.crouchVal * config.crouchAnimMlt);
      for (var ax = 0; ax < player.legMeshes.length; ++ax) {
        if (RENDER.lowSpec) {
          player.legMeshes[ax].visible = false;
        } else {
          player.legMeshes[ax].rotation.x =
            ai * (ax == 1 || ax == 3 ? 1 : -1) * 7 + (ax > 1 ? -0.6 : 0);
        }
      }
      for (ax = 0; ax < player.armMeshes.length; ++ax) {
        player.armMeshes[ax].position.z = ai * (ax ? -1 : 1);
        player.armMeshes[ax].rotation.x = player.armMeshes[ax].xR || 0;
        player.armMeshes[ax].rotation.y = player.armMeshes[ax].yR || 0;
        player.armMeshes[ax].position.x = player.armMeshes[ax].xP || 0;
        player.armMeshes[ax].position.y = player.armMeshes[ax].yP || 0;
        if (ax != 1) {
          if (player.meleeAnim && player.weaponGeos[player.weaponIndex]) {
            player.armMeshes[0].position.z += player.meleeAnim.lArm || 0;
            player.armMeshes[0].position.y -= (player.meleeAnim.lArm || 0) * 0.27;
            player.armMeshes[0].rotation.y += (player.meleeAnim.lArm || 0) * 0.1;
            player.armMeshes[0].position.x -= (player.meleeAnim.lArm || 0) * 0.3;
          }
        } else {
          player.armMeshes[1].rotation.z =
            player.armMeshes[ax].zR +
            player.crouchVal * 0.12 +
            al * -1 +
            player.jumpBobY * 0.2;
          if (player.weaponGeos[player.weaponIndex]) {
            player.weaponGeos[player.weaponIndex].rotation.z =
              player.weaponGeos[player.weaponIndex].zR;
            player.weaponGeos[player.weaponIndex].position.x =
              player.weaponGeos[player.weaponIndex].xP;
            player.weaponGeos[player.weaponIndex].position.y =
              player.weaponGeos[player.weaponIndex].yP;
            player.weaponGeos[player.weaponIndex].position.z =
              player.weaponGeos[player.weaponIndex].zP;
            player.weaponGeos[player.weaponIndex].rotation.y =
              player.weaponGeos[player.weaponIndex].yR;
            if (player.canThrow) {
              if (player.canThrow && !player.weaponGeos[player.weaponIndex].visible) {
                player.weaponGeos[player.weaponIndex].visible = true;
              }
            } else {
              player.weaponGeos[player.weaponIndex].visible = false;
            }
            if (player.aimVal < 1 && player.canThrow && player.weapon.canThrow) {
              var ay = 1 - player.aimVal;
              if (player.swapTime) {
                ay = 0;
              }
              player.armMeshes[1].rotation.z -= ay * 1.3;
              player.armMeshes[1].position.x += ay * 1.7;
              player.armMeshes[1].position.z += ay * 1.8;
              player.armMeshes[1].position.y += ay * 2.9;
              player.armMeshes[1].rotation.y += ay * 1;
              player.armMeshes[1].rotation.x += ay * 1.7;
            } else if (player.inspecting && player.canThrow) {
              player.armMeshes[1].rotation.z -= player.inspectAn.arZ;
              player.armMeshes[1].rotation.x -= player.inspectAn.arX * ap;
              player.armMeshes[1].rotation.y -= player.inspectAn.arY;
              player.armMeshes[1].position.z += player.inspectAn.apZ;
              player.armMeshes[1].position.x += player.inspectAn.apX * ap;
              player.armMeshes[1].position.y += player.inspectAn.apY;
              player.weaponGeos[player.weaponIndex].position.z += player.inspectAn.wpZ;
              player.weaponGeos[player.weaponIndex].position.y += player.inspectAn.wpY;
              player.weaponGeos[player.weaponIndex].rotation.y += player.inspectAn.wrY;
              player.weaponGeos[player.weaponIndex].rotation.z += player.inspectAn.wpSp;
            } else if (player.meleeAnim) {
              player.armMeshes[1].rotation.z += player.meleeAnim.armR || 0;
              player.armMeshes[1].rotation.y +=
                (player.meleeAnim.armT || 0) - (player.meleeAnim.rArm || 0) * 0.25;
              player.armMeshes[1].rotation.x += player.meleeAnim.armS || 0;
              player.armMeshes[1].position.x +=
                (player.meleeAnim.armM || 0) + (player.meleeAnim.rArm || 0) * 0.3;
              player.armMeshes[1].position.z +=
                (player.meleeAnim.armE || 0) + (player.meleeAnim.rArm || 0) * 1.15;
              player.armMeshes[1].position.y +=
                (player.meleeAnim.armY || 0) - (player.meleeAnim.rArm || 0) * 0.3;
              player.weaponGeos[player.weaponIndex].rotation.z += player.meleeAnim.weaR || 0;
              player.weaponGeos[player.weaponIndex].position.x += player.meleeAnim.weaM || 0;
              player.weaponGeos[player.weaponIndex].rotation.y += player.meleeAnim.flipW || 0;
            }
          }
        }
      }
      var az =
        player.weapon.attach != null && game.attach[player.attachIndex]
          ? game.attach[player.attachIndex]
          : null;
      var aA = (az && az.aimOffY + (player.weapon.aimOffY || 0)) || 0;
      if (player.renderYou && RENDER.weaponADSOffY != 1) {
        aA = (aA || 0.1) * RENDER.weaponADSOffY;
      }
      if (
        player.weaponMeshes[player.weaponIndex] &&
        player.weaponMeshes[player.weaponIndex].flapMesh &&
        player.weapon.flap
      ) {
        fRot =
          al * 3 +
          player.recoilAnim * 2.8 -
          player.leanAnimZ -
          player.leanAnimX * 3 -
          player.landBobYR * 1.8 +
          a9 +
          player.crouchVal * 0.1;
        RENDER.rotateMesh(
          player.weaponMeshes[player.weaponIndex].flapMesh,
          player.weapon.flap.rot * player.swapTweenA + fRot,
          null,
          null,
        );
      }
      var aB = game.store.skins[player.skins[player.weaponIndex]];
      var aC = Y ? 0.4 : 1;
      RENDER.rotateMesh(
        player.upperBody,
        at * (aC * -1),
        a9 * -0.2 +
          +ab +
          at * (aC * -2.8) +
          player.pitch * (player.renderYou && !Y ? 1 : 0.5) +
          ((-Math.PI / 4) * ao + player.recoilAnimY * config.recoilMlt) +
          (player.weapon.yRot || 0),
        RENDER.weaponRot * 0.35,
      );
      RENDER.moveMesh(
        player.upperBody,
        0,
        player.recoilAnimY * ((player.weapon.recoilYM || 0.3) * a4) +
          (player.height - config.cameraHeight - config.legHeight),
        0,
      );
      RENDER.rotateMesh(
        player.weaponMeshes[player.weaponIndex],
        player.inspectX * ap +
          player.jumpRotM * 0.2 +
          player.leanAnimX * a8 * RENDER.weaponLean * (player.weapon.leanMlt || 1) +
          (-ak * 0.16 * a3 * a2 + player.leanAnimZ * 0.2) * a1,
        -Math.cos(player.idleAnim) * ac * 0.01 * au +
          (player.weapon.rotOff || 0) * a3 +
          (player.weapon.rotOffA || 0) * (1 - a3) -
          (player.swapTweenR || 0) * 0.35 * a3 +
          -player.landBobYR * 0.4 +
          player.recoilTweenY * ag +
          player.leanAnimY * a8 * RENDER.weaponLean * (player.weapon.leanMlt || 1) +
          al * -0.9 * a1,
        ad +
          an +
          player.recoilTweenR * ag +
          player.leanAnimZ * 0.7 * a6 +
          -player.inspectX * ap * (player.weapon.inspectR || 0) +
          ((player.weapon.cLean || 0) * ap * player.crouchVal * a3 + -ak * 0) * a1,
      );
      RENDER.moveMesh(
        player.weaponMeshes[player.weaponIndex],
        player.recoilX * af +
          (player.swapTweenR || 0) * 0.2 -
          player.jumpRotM * a3 * 1.3 +
          -player.inspectX * ap * (player.weapon.inspectM || 0) +
          (player.leanAnimZ * 0.35 -
            (player.weapon.cRot || 0) * ap * player.crouchVal * a3 +
            ai * 0.5 * a2 * a3) *
            Z *
            a1 +
          aq -
          (aq - player.weapon.xOrg * ap) * am,
        player.recoilZ * af +
          Math.sin(player.idleAnim) * 0.02 * au +
          player.recoilTweenYM * ag +
          ae +
          aa * 0.5 -
          a9 * 1.5 -
          (player.weapon.bomb ? player.interProg * 3 : 0) +
          (aj * 0.85 - (player.weapon.cDrop || 0) * player.crouchVal * a3) * a1 +
          ar -
          (ar - player.weapon.yOrg + ((aB && aB.yOrg) || 0) + aA) * am,
        as -
          (as - player.weapon.zOrg) * am +
          player.recoilTweenZ +
          player.bobAnimZ * a1 +
          player.recoilAnim * (player.weapon.recoilZ || 0) * a5,
      );
    }
  };
  // GENERATE PLAYER MESH:
  this.generateMeshes = function (player, U, V = false) {
    player.leftHand = !!RENDER.leftHand;
    var W = game.classes[player.classIndex].colors;
    var X = config.skinColors[player.skinColIndex]
      ? config.skinColors[player.skinColIndex].col
      : UTILS.isHexColor(player.skinColIndex)
        ? player.skinColIndex
        : W[0];
    var Y = W[1];
    var Z = W[5];
    var a0 = W[2];
    var a1 = W[3];
    var a2 = UTILS.isHexColor(player.hairCol) ? player.hairCol : W[4];
    var a3 = {};
    if (config.isComp) {
      player.dyeIndex = -1;
    }
    if (player.dyeIndex != -1) {
      if ((a3 = game.store.skins[player.dyeIndex])) {
        if (a3.skinCol) {
          X = a3.skinCol;
        }
        if (a3.shirtCol) {
          Y = a3.shirtCol;
        }
        if (a3.sleeveCol) {
          Z = a3.sleeveCol;
        }
        if (a3.pantsCol) {
          a0 = a3.pantsCol;
        }
        if (a3.shoeCol) {
          a1 = a3.shoeCol;
        }
        if (a3.hairCol) {
          a2 = a3.hairCol;
        }
      } else {
        a3 = {};
      }
    }
    var a4 =
      game.config.thirdPerson ||
      (game.map.config &&
        (game.map.config.camOffX ||
          game.map.config.camOffY ||
          game.map.config.camOffZ)) ||
      !U;
    var a5 = RENDER.genObj3D(0, 0, 0);
    player.objInstances = RENDER.genObj3D(player.x, player.y, player.z, player.id);
    player.objInstances.add(a5);
    if (
      game.mode &&
      game.mode.teamOptions &&
      game.mode.teamOptions[player.team - 1] == "Infected"
    ) {
      X = COLORS.modeSpecific.infected.skin;
      player.hatIndex = 122;
    } else if (
      game.mode &&
      game.mode.teamOptions &&
      game.mode.teamOptions[player.team - 1] == "Stalker"
    ) {
      player.backIndex = -1;
      player.waistIndex = -1;
      player.hatIndex = -1;
      player.faceIndex = -1;
      player.meleeIndex = -1;
      X = COLORS.modeSpecific.stalker.skin;
      Y = COLORS.modeSpecific.stalker.body[1];
      Z = COLORS.modeSpecific.stalker.body[5];
      a0 = COLORS.modeSpecific.stalker.body[2];
      a1 = COLORS.modeSpecific.stalker.body[3];
      W = COLORS.modeSpecific.stalker.body;
    }
    if (game.map.config && game.map.config.mdl) {
      if (game.map.config.mdl == 1) {
        RENDER.loadSprite(
          {
            src: "sprite_0",
            color: 16777215,
            mat: THREE.SpriteMaterial,
            depthWrite: true,
            transparent: true,
            alphaTest: 0.02,
          },
          player.objInstances,
        );
      } else if (game.map.config.mdl == 2) {
        var a6 = game.map.config.aID || "";
        RENDER.loadMesh(
          {
            fileExt: a6.includes("g") ? "gltf" : null,
            src: a6.replace(/[^\d]/g, "") + "/model",
            color: 16777215,
            vertexColors: THREE.VertexColors,
            emissive: a6.includes("e") ? 16777215 : null,
            normal: a6.includes("n"),
            spec: a6.includes("s"),
            asset: a6.replace(/[^\d]/g, ""),
          },
          0,
          config.playerHeight / 2,
          0,
          0,
          game.map.config.mdlS || 1,
          player.objInstances,
          false,
        );
      }
    } else if (
      game.mode &&
      game.mode.teamOptions &&
      game.mode.teamOptions[player.team - 1] == "Prop"
    ) {
      var a7 = prefabs.prefabs[player.propID];
      RENDER.loadMesh(
        {
          src: a7.name.toLowerCase() + "_0",
          emissive: a7.name == "ACIDBARREL" ? 16777215 : null,
        },
        0,
        a7.scale + (a7.CPY || 0),
        0,
        0,
        a7.scale,
        player.objInstances,
        false,
      );
    } else {
      var a8;
      var a9;
      var aa = false;
      if (player.hatIndex >= 0 && a4) {
        a9 = game.store.skins[player.hatIndex];
      }
      player.lowerBody = RENDER.genObj3D(0, config.legHeight, 0);
      if (a4) {
        player.lowerBody.add(
          RENDER.genBody(player.renderYou, {
            shirtCol: Y,
            pantsCol: a0,
            hairCol: a2,
            skinCol: X,
            rgb: a3.rgb,
            rgbS: a3.rgbS || 0,
            noHead: !!a9 && a9.noHead,
            transparent: a3.opac != null,
            opacity: a3.opac || 1,
            texSrc: a3.tex ? a3.tex : null,
            movT: a3.movT,
            movD: a3.movD,
            emissive: a3.glow || a3.sameGlow ? a3.emiss || 16777215 : null,
            color: a3 ? a3.color : null,
            sameGlow: a3.sameGlow,
            repeatY: a3.tileS || 0,
            repeatX: a3.tileS || 0,
          }),
        );
      }
      player.upperBody = RENDER.genObj3D(0, 0, 0);
      player.lowerBody.add(player.upperBody);
      if (player.backIndex >= 0 && a4) {
        a8 = game.store.skins[player.backIndex];
        player.backMesh = RENDER.genObj3D(
          0,
          (config.playerHeight - config.legHeight - config.headScale) / 2 -
            (a8.sitOff || 0),
          -(a8.sitOffZ || 0),
        );
        player.lowerBody.add(player.backMesh);
        RENDER.loadMesh(
          {
            local: a8.local,
            localM: a8.localM,
            src: "body/body_" + a8.id,
            texSrc: a8.tex ? "body/body_" + a8.id + "_" + a8.tex : null,
            frames: a8.frames,
            frameT: a8.frameT,
            movT: a8.movT,
            movD: a8.movD,
            sameGlow: a8.sameGlow,
            glowText: a8.glow,
            emissive: a8.glow || a8.sameGlow ? a8.emiss || 16777215 : null,
            noGreen: true,
            transparent: a8.opac != null || a8.trans,
            rAnim: a8.rAnim,
            rAnimA: a8.rAnimA,
            rgb: a8.rgb || (!!a3 && a3.rgb),
            rgbS: a8.rgbS || (a3 ? a3.rgbS : 0),
            rgbT: a8.rgbT,
            wireframe: a8.wire,
            side: a8.side || 0,
            opacity: a8.opac || 1,
            shaderId: a8.shaderId,
            color: a8.color || null,
          },
          0,
          0,
          0,
          Math.PI / 2,
          (a8.sclMlt || 1) * 2.1,
          player.backMesh,
        );
      }
      if (player.waistIndex >= 0 && a4) {
        a8 = game.store.skins[player.waistIndex];
        player.waistMesh = RENDER.genObj3D(
          0,
          (config.playerHeight - config.legHeight - config.headScale - 2) / 2 -
            (a8.sitOff || 0),
          -(a8.sitOffZ || 0),
        );
        player.lowerBody.add(player.waistMesh);
        if (a8.noLegs) {
          aa = true;
        }
        RENDER.loadMesh(
          {
            local: a8.local,
            localM: a8.localM,
            src: "waist/waist_" + a8.id,
            texSrc: a8.tex ? "waist/waist_" + a8.id + "_" + a8.tex : null,
            frames: a8.frames,
            frameT: a8.frameT,
            movT: a8.movT,
            movD: a8.movD,
            sameGlow: a8.sameGlow,
            glowText: a8.glow,
            emissive: a8.glow || a8.sameGlow ? a8.emiss || 16777215 : null,
            noGreen: true,
            transparent: a8.opac != null || a8.trans,
            rAnim: a8.rAnim,
            rAnimA: a8.rAnimA,
            rgb: a8.rgb || (!!a3 && a3.rgb),
            rgbS: a8.rgbS || (a3 ? a3.rgbS : 0),
            rgbT: a8.rgbT,
            wireframe: a8.wire,
            side: a8.side || 0,
            opacity: a8.opac || 1,
            alphaTest: a8.alpha || 0,
            shaderId: a8.shaderId,
            color: a8.color || null,
          },
          0,
          0,
          0,
          Math.PI / 2,
          (a8.sclMlt || 1) * 2.1,
          player.waistMesh,
        );
      }
      if (a9) {
        player.hatMesh = RENDER.genObj3D(
          0,
          config.playerHeight - config.legHeight - (a9.sitOff || 0),
          -(a9.sitOffZ || 0),
        );
        player.lowerBody.add(player.hatMesh);
        RENDER.loadMesh(
          {
            local: a9.local,
            localM: a9.localM,
            src: "hats/hat_" + a9.id,
            texSrc: a9.tex ? "hats/hat_" + a9.id + "_" + a9.tex : null,
            frames: a9.frames,
            frameT: a9.frameT,
            movT: a9.movT,
            movD: a9.movD,
            sameGlow: a9.sameGlow,
            glowText: a9.glow,
            emissive: a9.glow || a9.sameGlow ? a9.emiss || 16777215 : null,
            noGreen: true,
            transparent: a9.opac != null || a9.trans,
            rAnim: a9.rAnim,
            rAnimA: a9.rAnimA,
            rgb: a9.rgb || (!!a3 && a3.rgb),
            rgbS: a9.rgbS || (a3 ? a3.rgbS : 0),
            rgbT: a9.rgbT,
            wireframe: a9.wire,
            side: a9.side || 0,
            opacity: a9.opac || 1,
            shaderId: a9.shaderId,
            color: a9.color || null,
          },
          0,
          0,
          0,
          Math.PI / 2,
          (a9.sclMlt || 1) * 2.1,
          player.hatMesh,
        );
      }
      if (player.faceIndex >= 0 && a4) {
        a8 = game.store.skins[player.faceIndex];
        player.faceMesh = RENDER.genObj3D(
          0,
          config.playerHeight - config.legHeight - (a8.sitOff || 0),
          -(a8.sitOffZ || 0),
        );
        player.lowerBody.add(player.faceMesh);
        RENDER.loadMesh(
          {
            local: a8.local,
            localM: a8.localM,
            src: "faces/face_" + a8.id,
            texSrc: a8.tex ? "faces/face_" + a8.id + "_" + a8.tex : null,
            frames: a8.frames,
            frameT: a8.frameT,
            movT: a8.movT,
            movD: a8.movD,
            sameGlow: a8.sameGlow,
            glowText: a8.glow,
            emissive: a8.glow || a8.sameGlow ? a8.emiss || 16777215 : null,
            noGreen: true,
            transparent: a8.opac != null || a8.trans,
            rAnim: a8.rAnim,
            rAnimA: a8.rAnimA,
            rgb: a8.rgb || (!!a3 && a3.rgb),
            rgbS: a8.rgbS || (a3 ? a3.rgbS : 0),
            rgbT: a8.rgbT,
            wireframe: a8.wire,
            side: a8.side || 0,
            opacity: a8.opac || 1,
            shaderId: a8.shaderId,
            color: a8.color || null,
          },
          0,
          0,
          0,
          Math.PI / 2,
          (a8.sclMlt || 1) * 1,
          player.faceMesh,
        );
      }
      if (a4 && !aa) {
        for (var ab = 0; ab < 4; ++ab) {
          player.legMeshes.push(
            RENDER.genLeg(ab == 1 || ab == 3, a0, a1, {
              crouch: ab > 1,
              rgb: !!a3 && a3.rgb,
              rgbS: a3 ? a3.rgbS : 0,
              transparent: a3.opac != null,
              opacity: a3.opac || 1,
              texSrc: a3.tex ? a3.tex : null,
              movT: a3.movT,
              movD: a3.movD,
              emissive: a3.glow || a3.sameGlow ? a3.emiss || 16777215 : null,
              color: a3 ? a3.color : null,
              sameGlow: a3.sameGlow,
              repeatY: a3.tileS || 0,
              repeatX: a3.tileS || 0,
            }),
          );
          if (ab >= 2) {
            RENDER.rotateMesh(
              player.legMeshes[ab],
              ab == 2 ? -Math.PI / 6 : Math.PI / 8,
              0,
              0,
            );
          }
          player.legMeshes[ab].visible = ab <= 1;
          a5.add(player.legMeshes[ab]);
        }
      }
      for (ab = 0; ab < player.ammos.length; ++ab) {
        var ac = RENDER.genObj3D(0, 0, 0);
        var ad = game.weaponConfig[player.loadout[ab]];
        var ae = game.store.skins[ad.melee ? player.meleeIndex : player.skins[ab]];
        if (!ae) {
          ae = {};
          if (ad.altSkin) {
            ae = ad.altSkin || {};
          }
        }
        if (!ad.melee && ae && ae.weapon - 1 != player.loadout[ab]) {
          ae = {};
        }
        var af =
          ad.attach != null && game.attach[player.attachIndex]
            ? game.attach[player.attachIndex]
            : null;
        if (player.isYou && ad.ammo) {
          ac.muzzles = [];
          ac.casings = [];
          for (var ag = 0; ag < 2; ++ag) {
            if (!ag || ad.akimbo) {
              ac.muzzles.push(new THREE.Sprite());
              ac.muzzles[ag].visible = false;
              ac.muzzles[ag].static = true;
              PARTICLES.particles.push(ac.muzzles[ag]);
              ac.add(ac.muzzles[ag]);
              ac.casings.push(
                RENDER.genObj3D(
                  ag ? -ad.xOff * 2 : 0,
                  ad.caseYOff || 0,
                  ad.caseZOff || 0,
                ),
              );
              ac.add(ac.casings[ag]);
            }
          }
          ac.muzzleFlash = RENDER.genObj3D(0, 0.4, 0);
          ac.muzzles[0].add(ac.muzzleFlash);
        }
        if (ad.src || !player.renderYou) {
          ac.add(
            RENDER.genArms(ad, null, !a4, {
              shirtCol: Y,
              sleeveCol: Z,
              skinCol: X,
              armS: 1,
              leftHand: player.leftHand,
              rgb: !!a3 && a3.rgb,
              rgbS: a3 ? a3.rgbS : 0,
              transparent: a3.opac != null,
              opacity: a3.opac || 1,
              texSrc: a3.tex ? a3.tex : null,
              movT: a3.movT,
              movD: a3.movD,
              emissive: a3.glow || a3.sameGlow ? a3.emiss || 16777215 : null,
              color: a3 ? a3.color : null,
              sameGlow: a3.sameGlow,
              repeatY: a3.tileS || 0,
              repeatX: a3.tileS || 0,
            }),
          );
        } else {
          var ah;
          for (ag = 0; ag < 2; ++ag) {
            ah = RENDER.genArms(ad, ag + 1, !a4, {
              shirtCol: Y,
              sleeveCol: Z,
              skinCol: X,
              armS: 1,
              rgb: !!a3 && a3.rgb,
              rgbS: a3 ? a3.rgbS : 0,
              transparent: a3.opac != null,
              opacity: a3.opac || 1,
              texSrc: a3.tex ? a3.tex : null,
              movT: a3.movT,
              movD: a3.movD,
              emissive: a3.glow || a3.sameGlow ? a3.emiss || 16777215 : null,
              color: a3 ? a3.color : null,
              sameGlow: a3.sameGlow,
              repeatY: a3.tileS || 0,
              repeatX: a3.tileS || 0,
            });
            ac.add(ah);
            player.armMeshes.push(ah);
          }
        }
        player.weaponMeshes.push(ac);
        player.weaponMeshes[ab].visible = false;
        player.upperBody.add(player.weaponMeshes[ab]);
        if (
          ad.melee &&
          (!!player.renderYou ||
            !game.mode ||
            !game.mode.teamOptions ||
            game.mode.teamOptions[player.team - 1] != "Infected")
        ) {
          player.weaponGeos[ab] = RENDER.loadMesh(
            {
              local: ae.local,
              localM: ae.localM,
              src: "melee/melee_" + (ae.id || 0),
              texSrc:
                game.mode &&
                game.mode.teamOptions &&
                game.mode.teamOptions[player.team - 1] == "Stalker"
                  ? "melee/melee_0_5"
                  : ae.pat
                    ? ae.tex
                    : ae.tex
                      ? "melee/melee_" + (ae.id || 0) + "_" + ae.tex
                      : "",
              sameGlow: ae.sameGlow,
              glowText: ae.glow || ae.sameGlow,
              emissive: ae.glow || ae.sameGlow ? ae.emiss || 16777215 : null,
              movT: ae.movT,
              movD: ae.movD,
              pulsT: ae.pulsT,
              minGlo: ae.minGlo,
              frameT: ae.frameT,
              tFilter: THREE.LinearFilter,
              frames: ae.frames,
              transparent: ae.opac != null || ad.seeThrough,
              mat:
                V || player.renderYou
                  ? RENDER.weaponShine
                    ? THREE.MeshPhongMaterial
                    : THREE.MeshLambertMaterial
                  : null,
              noGreen: true,
              uv2: true,
              specular: 2697513,
              shininess: 100,
              rgb: ae.rgb,
              rgbS: ae.rgbS,
              rgbT: ae.rgbT,
              wireframe: ae.wire,
              side: ae.side || 0,
              opacity: ae.opac || 1,
              alphaTest: ae.alpha || 0,
              shaderId: ae.shaderId,
              color: ae.color || null,
            },
            (player.renderYou ? 0.9 : 1.7) + ((player.renderYou && ae.sxOff) || 0),
            (player.renderYou ? -0.95 : -0.4) + ((player.renderYou && ae.syOff) || 0),
            (player.renderYou ? 0.72 : 1.2) + ((player.renderYou && ae.szOff) || 0),
            [
              -Math.PI / 3.5,
              player.renderYou ? 0.3 + (ae.flip ? Math.PI : 0) : Math.PI / 2,
              Math.PI * -0.9 + ((player.renderYou && ae.sxRot) || 0),
            ],
            ae.sclMlt || 0.9,
            player.armMeshes[1] ? player.armMeshes[1] : player.weaponMeshes[ab],
          );
          if (player.armMeshes[1]) {
            player.armMeshes[1].yR = player.armMeshes[1].rotation.y;
            if (player.renderYou) {
              player.armMeshes[1].zR = player.armMeshes[1].rotation.z = -0.3;
              player.armMeshes[1].xR = player.armMeshes[1].rotation.x = -0.4;
              player.armMeshes[1].xP = player.armMeshes[1].position.x = 0.4;
              player.armMeshes[1].yP = player.armMeshes[1].position.y = 0.3;
            } else {
              player.armMeshes[1].zR = player.armMeshes[1].rotation.z = 0.3;
              player.armMeshes[1].yP = player.armMeshes[1].position.y = -0.4;
              player.armMeshes[1].xR = player.armMeshes[1].rotation.x;
              player.armMeshes[1].xP = player.armMeshes[1].position.x = -0.2;
            }
            player.armMeshes[0].xP = player.armMeshes[0].position.x = 0.3;
            player.armMeshes[0].yP = player.armMeshes[0].position.y = -0.5;
            player.armMeshes[0].zR = player.armMeshes[0].rotation.z = -0.4;
            player.armMeshes[0].yR = player.armMeshes[0].rotation.y;
          }
        }
        if (ad.src) {
          var ai = player.skins[ab] >= 0 && (ae.glow || ae.sameGlow);
          for (ag = 0; ag < 2; ++ag) {
            if (!ag || ad.akimbo) {
              RENDER.loadMesh(
                {
                  local: ae.local,
                  localM: ae.localM,
                  src:
                    "weapons/" + ad.src + (ae.mid == null ? "" : "_" + ae.mid),
                  texSrc:
                    ae.mid == null
                      ? ae.tex
                        ? ae.tex
                        : ae && ae.id != null
                          ? "weapons/skins/" + ad.src + "_" + ae.id
                          : null
                      : UTILS.getReModel(game.store, ae),
                  tFilter: THREE.LinearFilter,
                  mat:
                    V || player.renderYou
                      ? RENDER.weaponShine
                        ? THREE.MeshPhongMaterial
                        : THREE.MeshLambertMaterial
                      : null,
                  frames: ae.frames,
                  frameT: ae.frameT,
                  pulsT: ae.pulsT,
                  minGlo: ae.minGlo,
                  shadows: RENDER.highResShad,
                  movT: ae.movT,
                  movD: ae.movD,
                  repeatY: ae.tileS || 0,
                  repeatX: ae.tileS || 0,
                  sameGlow: ae.sameGlow,
                  glowText: ai,
                  noGreen: true,
                  uv2: true,
                  ao: U && !ad.noAo,
                  shininess: ae.shine || ad.shine || 60,
                  specular: 2697513,
                  transparent: ae.opac != null || ad.seeThrough,
                  emissive:
                    (!ad.transp && !ai) || ae.noEmis
                      ? null
                      : ae.emiss || 16777215,
                  rgb: ae.rgb,
                  rgbS: ae.rgbS,
                  rgbT: ae.rgbT,
                  wireframe: ae.wire,
                  side: ae.side || 0,
                  opacity: ae.opac || 1,
                  shaderId: ae.shaderId,
                  color: ae.color || null,
                },
                ag == 1 ? ad.xOff * -2 : 0,
                ae.yOff || 0,
                ae.zOff || 0,
                ad.rot || Math.PI / 2,
                ae.mScl || ad.scale,
                player.weaponMeshes[ab],
              );
            }
          }
        }
        if (U && ad.flap && RENDER.sniperFlap) {
          player.weaponMeshes[ab].flapMesh = RENDER.loadMesh(
            {
              src: "attach/" + ad.flap.src,
              tFilter: THREE.LinearFilter,
              noGreen: true,
              mat: RENDER.weaponShine
                ? THREE.MeshPhongMaterial
                : THREE.MeshLambertMaterial,
              shininess: 60,
              transparent: true,
            },
            ad.flap.xOff,
            ad.flap.yOff,
            ad.flap.zOff,
            Math.PI / 2,
            ad.flap.scl,
            player.weaponMeshes[ab],
          );
        }
        if (af && (U || V)) {
          RENDER.loadMesh(
            {
              src: "attach/" + af.src,
              tFilter: THREE.LinearFilter,
              noGreen: true,
              shininess: 60,
              mat:
                V || player.renderYou
                  ? RENDER.weaponShine
                    ? THREE.MeshPhongMaterial
                    : THREE.MeshLambertMaterial
                  : null,
              specular: 2697513,
              transparent: true,
            },
            0,
            -(ad.yOrg || 0) + (ad.attachYOff || 0),
            -(ad.attachZOff || 0),
            Math.PI / 2,
            af.scale,
            player.weaponMeshes[ab],
          );
        }
      }
      a5.add(player.lowerBody);
      if (!a4) {
        player.objInstances.traverse(function (aj) {
          aj.layers.set(1);
        });
      }
    }
    return player.objInstances;
  };
  this.pickProp = function (player) {
    if (
      IO &&
      player &&
      player.active &&
      (!player.lastPropPick || game.now - player.lastPropPick >= 200)
    ) {
      player.lastPropPick = game.now;
      var Q = player.yaw;
      var R = player.pitch;
      L.length = 0;
      var S;
      var T = 0;
      var U = 1 / (Math.sin(Q + Math.PI) * 25 * Math.cos(R));
      var V = 1 / (Math.cos(Q + Math.PI) * 25 * Math.cos(R));
      var W = 1 / (Math.sin(R) * 25);
      var X = player.y + player.height - config.cameraHeight;
      for (var Y = 0; Y < game.map.manager.objects.length; ++Y) {
        if (
          (S = game.map.manager.objects[Y]).active &&
          S.propID &&
          !S.noShoot
        ) {
          if (
            (T = UTILS.lineInRect(
              player.x,
              player.z,
              X,
              U,
              V,
              W,
              S.x - S.width,
              S.z - S.length,
              S.y - S.height,
              S.x + S.width,
              S.z + S.length,
              S.y + S.height,
            )) &&
            T <= 1
          ) {
            L.push({
              obj: S,
              dst: T,
            });
          }
        }
      }
      if (L.length) {
        L.sort(UTILS.orderByDst);
        if (L[0] && L[0].obj) {
          this.updateProp(player, prefabs.getPrefabIdByName(L[0].obj.propID));
        }
      }
    }
  };
  // REGENERATE MESHES:
  this.regenMeshes = function (player) {
    if (player.objInstances) {
      this.disposeMesh(player, true);
    }
    if (RENDER) {
      this.generateMeshes(player, player.renderYou);
      RENDER.add(player.objInstances);
    }
    this.reload(player, 0, true);
    if (player.isYou && RENDER) {
      this.resetAim();
    }
  };
  // HIDE:
  this.hideAll = function () {
    for (var P = 0; P < this.list.length; ++P) {
      if (
        this.list[P].active &&
        this.list[P].objInstances &&
        ((this.list[P].forcePos = !this.list[P].latestData),
        (this.list[P].latestData = false),
        !this.list[P].isYou)
      ) {
        this.list[P].objInstances.visible = false;
      }
    }
  };
  // CLEAR ALL PLAYERS:
  this.clear = function () {
    if (RENDER) {
      for (var P = 0; P < this.list.length; ++P) {
        this.disposeMesh(this.list[P]);
      }
    }
    this.list.length = 0;
  };
  // TOGGLE LOD:
  this.toggleLOD = function (player, vis) {
    if (player.latestData) {
      if (player.objInstances) {
        player.objInstances.visible = vis;
      }
      player.lodActive = !vis;
    }
  };
  // DISPOSE PLAYER MESH:
  this.disposeMesh = function (player) {
    RENDER.remove(player.objInstances);
    player.objInstances = null;
    player.objInstances = null;
    player.faceMesh = null;
    player.hatMesh = null;
    player.backMesh = null;
    player.waistMesh = null;
    player.weaponMeshes.length = 0;
    player.weaponGeos = {};
    player.armMeshes.length = 0;
    player.legMeshes.length = 0;
  };
  this.updateProp = function (player, Q, R) {
    if (player && player.active) {
      if (Q != null) {
        player.propID = Q;
      }
      var S = prefabs.prefabs[Q].scale;
      var T = prefabs.prefabs[Q].CP || 0;
      player.height = S + T;
      player.scale = S + T;
      if (R) {
        this.regenMeshes(player);
      }
      if (IO) {
        window.IO.broadcast("game" + game.sid, "up", player.sid, Q);
      }
    }
  };
  // REMOVE PLAYER:
  this.remove = function (P) {
    var Q = this.indexBySid(P);
    if (Q >= 0) {
      if (IO && this.list[Q]) {
        game.dropFlag(this.list[Q].flag);
        this.dropWeapon(this.list[Q], true);
      }
      var R = this.list[Q].id;
      if (this.list[Q].objInstances) {
        this.disposeMesh(this.list[Q]);
      }
      this.list.splice(Q, 1);
      if (IO) {
        for (var S = this.list.length - 1; S >= 0; --S) {
          if ((Q = this.list[S].sentTo.indexOf(R)) >= 0) {
            this.list[S].sentTo.splice(Q, 1);
          }
        }
        window.IO.broadcast("game" + game.sid, "2", P);
        this.syncLeaders(true);
      }
      if (typeof window != "undefined" && "updateWindow" in window) {
        window.updateWindow(23);
      }
    }
  };
  // ADD PLAYER:
  this.add = function (
    id,
    U,
    V,
    W,
    X,
    Y,
    Z,
    skins,
    faceIndex,
    hatIndex,
    backIndex,
    waistIndex,
    meleeIndex,
    skinColIndex,
    hairCol,
    dyeIndex,
    attachIndex,
    kcStatIndex,
    secIndex,
    ac,
    ad,
    ae,
    af,
    ag,
    ah,
    virus,
    alias,
  ) {
    var player;
    for (var al = 0; al < this.list.length; ++al) {
      if (this.list[al].id == id) {
        player = this.list[al];
        break;
      }
    }
    if (player) {
      if (RENDER && player.objInstances) {
        this.disposeMesh(player);
      }
      player.weaponMeshes.length = 0;
      player.weaponGeos = {};
      player.legMeshes.length = 0;
      player.armMeshes.length = 0;
    } else {
      (player = new Player(id, this, UTILS, COLORS, config, game, ae)).sid =
        U || UTILS.generateSID(this.list);
      this.list.push(player);
    }
    Y ||= "Guest_" + player.sid;
    player.init(X, V, W, Y, ae, af);
    player.tmpAccountName = ah;
    if (IO && game.mode != null) {
      this.setTeam(player);
    }
    if (ad) {
      player.team = ad;
    }
    player.skins = skins || [-1, -1];
    player.faceIndex = faceIndex;
    player.hatIndex = hatIndex;
    player.backIndex = backIndex;
    player.waistIndex = waistIndex;
    player.meleeIndex = meleeIndex;
    player.skinColIndex = skinColIndex;
    player.hairCol = hairCol;
    player.dyeIndex = dyeIndex;
    player.kcStatIndex = kcStatIndex;
    player.attachIndex = attachIndex;
    player.secIndex = secIndex;
    player.virus = virus;
    player.alias = alias || Y;
    player.setClass(game, Z, secIndex, !!RENDER);
    if (!ag && game.mode.startingLoadout) {
      ag = game.mode.startingLoadout;
    }
    if (ag) {
      player.updateLoadout(game, player.weaponIndex, false, ...ag);
    }
    if (game.mode && game.mode.objWep) {
      player.updateLoadout(
        game,
        player.weaponIndex,
        false,
        game.activeObjective,
      );
    }
    if (RENDER) {
      this.generateMeshes(player, player.renderYou);
      var am = player;
      RENDER.add(am.objInstances);
    }
    if (
      game.mode &&
      game.mode.teamOptions &&
      game.mode.teamOptions[player.team - 1] == "Prop"
    ) {
      this.updateProp(player, ac || 1, true);
    }
    this.reload(player, 0, true);
    if (typeof window != "undefined" && "updateWindow" in window) {
      window.updateWindow(23);
    }
    return player;
  };
  var K = [0, 1, 2];
  // GET STEP SOUND:
  this.getStepSound = function () {
    return K[UTILS.randInt(0, K.length - 1)];
  };
  // RESET STEP:
  this.resetStep = function (player, Q) {
    if (!Q && player.renderYou && player.velY) {
      if (player.jumpTween) {
        player.jumpTween.stop();
      }
      if (player.landTween) {
        player.landTween.stop();
      }
      player.landTween = new TWEEN.Tween(player)
        .to(
          {
            landBobY: player.velY * 6,
            jumpBobY: 0,
          },
          100,
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(function () {
          player.landTween = new TWEEN.Tween(player)
            .to(
              {
                landBobY: 0,
              },
              1100,
            )
            .easing(TWEEN.Easing.Elastic.Out)
            .start();
        })
        .start();
    }
    if (
      !!SOUND &&
      !Q &&
      !!player.velY &&
      (!game.mode ||
        !game.mode.teamOptions ||
        game.mode.teamOptions[player.team - 1] != "Stalker")
    ) {
      if (player.stepSrc) {
        player.stepSrc;
      }
      SOUND.play("step_" + this.getStepSound(), 0.7, false);
      if (
        player.renderYou &&
        player.crouchVal &&
        !game.mode.realMov &&
        game.config.canSlide &&
        player.canSlide
      ) {
        SOUND.play("slide_0", 0.35, false);
      }
    }
    if (
      game.config.canSlide &&
      !game.mode.realMov &&
      player.crouchVal &&
      player.canSlide
    ) {
      player.canSlide = false;
      player.slideTimer =
        config.slideTime *
        (game.config.slidTime || 1) *
        game.map.config.slT *
        player.crouchVal;
      var R =
        (this.onTerrain
          ? config.playerTerrainSlideVelMlt
          : config.playerSlideVelMlt) * game.map.config.slA;
      player.velX *= R;
      player.velZ *= R;
    }
  };
  // PLAYER STEP:
  this.playerStep = function (player, Q, R) {
    if (
      Q &&
      (!player.renderYou && player.crouchVal && (Q *= 1.6),
      (player.stepVal += Q * config.stepMlt * player.stepDir),
      (player.stepVal >= Math.PI / 2 && player.stepDir == 1) ||
        (player.stepVal <= -Math.PI / 2 && player.stepDir == -1))
    ) {
      if (
        SOUND &&
        !R &&
        (!game.mode ||
          !game.mode.teamOptions ||
          game.mode.teamOptions[player.team - 1] != "Stalker")
      ) {
        var S =
          UTILS.randFloat(0.15, 0.25) *
          (player.crouchVal < 1 ? 1 : player.isYou ? 0.5 : 0);
        var T = player.crouchVal < 1 ? 1 : 0.8;
        var U = player.stepSrc ? "_" + player.stepSrc : "";
        if (player.isYou) {
          SOUND.play("step_" + this.getStepSound() + U, S, false, T);
        } else if (S) {
          game.playerSound(
            config.networkSounds.indexOf("step_" + UTILS.randInt(0, 2) + U),
            player.sid,
            player.x,
            player.y,
            player.z,
            S,
            T,
            170,
            true,
          );
        }
      }
      player.stepDir *= -1;
    }
  };
  // JUMP:
  this.jump = function (player) {
    player.didAct = true;
    player.jumpTimer =
      (player.terrainSlipping ? config.playerSlippingJumpCooldown : 0) *
      game.map.config.jpC;
    player.didJump = true;
    player.didJumpW = true;
    player.onTerrain = false;
    var Q = config.jumpVel * (game.config ? game.config.jumpMlt : 1);
    if (game.mode.realMov) {
      Q *= 0.92;
    }
    var R = config.jumpPush * (game.config ? game.config.jumpMlt : 1);
    player.velY +=
      (Q - Q * (config.crouchJump * player.crouchVal)) *
      (player.weapon.jumMlt || player.weapon.spdMlt) *
      (player.aimVal ? 1 : config.aimJumpSlow);
    var S = UTILS.distance2D(0, 0, player.velX, player.velZ);
    player.velX -= R * S * Math.sin(player.yaw);
    player.velZ -= R * S * Math.cos(player.yaw);
    if (SOUND && !player.recon && player.renderYou) {
      if (player.landTween) {
        player.landTween.stop();
      }
      player.landTween = new TWEEN.Tween(player)
        .to(
          {
            landBobY: 0,
          },
          100,
        )
        .easing(TWEEN.Easing.Linear.None)
        .start();
      if (player.jumpTween) {
        player.jumpTween.stop();
      }
      player.jumpTween = new TWEEN.Tween(player)
        .to(
          {
            jumpBobY: 0.22,
          },
          500,
        )
        .easing(TWEEN.Easing.Back.Out)
        .start();
      var T = UTILS.randFloat(0.12, 0.15);
      new TWEEN.Tween(player)
        .to(
          {
            jumpRot: [T, 0],
          },
          900,
        )
        .easing(TWEEN.Easing.Back.Out)
        .start();
      SOUND.play("jump_" + UTILS.randInt(0, 1), 0.04, false);
    }
  };
  // TRY TO JUMP:
  this.tryJump = function (player, Q) {
    if (game.config && game.config.autoJump && Q) {
      this.jump(player);
    } else {
      if (player.didJump && !Q) {
        player.didJump = false;
      }
      if (!player.didJump && Q) {
        this.jump(player);
      }
    }
  };
  // TOGGLE AIM:
  this.toggleAim = function (player, Q) {
    if (!!SOUND && !player.recon && !player.weapon.melee) {
      SOUND.play("aim_" + Q, 0.1);
    }
    if (
      !Q ||
      (game.mode &&
        game.mode.teamOptions &&
        game.mode.teamOptions[player.team - 1] == "Prop")
    ) {
      this.resetAim();
    }
    if (
      game.controls.camType.isNormal &&
      player.weapon.scope &&
      player.weaponMeshes &&
      player.weaponMeshes[player.weaponIndex]
    ) {
      RENDER.zoom(Q ? 1 + (player.weapon.zoom - 1) * RENDER.adsFovMlt : 1);
      player.weaponMeshes[player.weaponIndex].visible =
        !this.isWeaponHidden(player, player.weaponIndex) && !Q;
      if (RENDER.aimRecticle.custom) {
        aimRecticle.style.opacity = Q ? 1 : 0;
      } else {
        RENDER.aimRecticle.opacity = Q ? 1 : 0;
      }
    }
    var R =
      player.weapon.attach != null && game.attach[player.attachIndex]
        ? game.attach[player.attachIndex]
        : null;
    if (game.controls.camType.isNormal && R) {
      if (RENDER.aimDot.custom) {
        aimDot.style.opacity = Q ? 1 : 0;
        aimDot.style.display = RENDER.aimDot.display ? "" : "none";
      } else {
        RENDER.aimDot.opacity = Q ? 1 : 0;
      }
    }
    if (
      game.controls.camType.isNormal &&
      player.weaponMeshes &&
      player.weaponMeshes[player.weaponIndex] &&
      RENDER.hideADS
    ) {
      player.weaponMeshes[player.weaponIndex].visible =
        !Q && !this.isWeaponHidden(player, player.weaponIndex);
    }
  };
  // UPDATE AIM:
  this.updateAim = function (player, Q) {
    RENDER.zoom(1 + (player.weapon.zoom - 1) * Q * RENDER.adsFovMlt);
  };
  this.isWeaponHidden = function (player, Q) {
    var R = player.loadout[Q];
    return (
      (!!game.weaponConfig[R].melee && !!game.hideWeapon[2]) ||
      (!!game.weaponConfig[R].secondary && !!game.hideWeapon[1]) ||
      (!game.weaponConfig[R].melee &&
        !game.weaponConfig[R].secondary &&
        !!game.hideWeapon[0])
    );
  };
  this.startReload = function (player) {
    if (player.weapon && !player.reloadTimer && player.ammos[player.weaponIndex] < player.weapon.ammo) {
      if (SOUND) {
        SOUND.play("reload_1", 0.25);
      }
      player.reloadTimer = player.weapon.reload * (game.config.reSpd || 1);
      player.burstCount = 0;
      if (player.isYou) {
        this.cancelInspect(player);
        if (RENDER) {
          ammoDisplay.style.backgroundSize = "100%";
        }
      }
    }
  };
  this.reloadUIAnim = function (player) {
    if (RENDER && player.isYou) {
      ammoDisplay.style.backgroundSize =
        Math.max(
          (player.reloadTimer / (player.weapon.reload * (game.config.reSpd || 1))) * 100,
          0,
        ).round() + "%  100%";
    }
  };
  // END RELOAD:
  this.endReload = function (P) {
    if (SOUND) {
      SOUND.play("reload_2" + (P.custReload || ""), 0.25);
    }
  };
  this.resetReloadUIAnim = function () {
    if (RENDER) {
      ammoDisplay.style.backgroundSize = "0%";
    }
  };
  // RESET AIM:
  this.resetAim = function () {
    RENDER.zoom(1);
    RENDER.aimRecticle.opacity = 0;
    RENDER.aimDot.opacity = 0;
    aimRecticle.style.opacity = 0;
    aimDot.style.opacity = 0;
  };
  // UPDATE PLAYER AMMO:
  this.updatePlayerAmmo = function (player) {
    if (player.isYou) {
      if (ammoDisplay.style.display != "inline-block") {
        ammoDisplay.style.display = "inline-block";
      }
      if (ammoVal.firstChild) {
        ammoVal.firstChild.nodeValue =
          player.ammos[player.weaponIndex] || (player.weapon.melee ? "-" : 0);
      } else {
        ammoVal.textContent =
          player.ammos[player.weaponIndex] || (player.weapon.melee ? "-" : 0);
      }
      if (ammoMax.firstChild) {
        ammoMax.firstChild.nodeValue =
          "| " +
          (game.mode && game.mode.ammoLimit != null
            ? "-"
            : player.weapon.ammo || "-");
      } else {
        ammoMax.textContent =
          "| " +
          (game.mode && game.mode.ammoLimit != null
            ? "-"
            : player.weapon.ammo || "-");
      }
      if (
        player.ammos[player.weaponIndex] <= 0 &&
        game.mode &&
        game.mode.ammoLimit == null
      ) {
        if (reloadMsg.style.display != "block") {
          reloadMsg.style.display = "block";
        }
      } else if (reloadMsg.style.display != "none") {
        reloadMsg.style.display = "none";
      }
    }
  };
  // INSPECT WEAPON:
  this.wInspect = function (player) {
    if (player.inspecting) {
      this.cancelInspect(player);
    } else if (
      !player.weapon.nInsp &&
      !player.inspecting &&
      player.aimVal == 1 &&
      !player.reloadTimer &&
      (!player.weapon.melee || player.canThrow)
    ) {
      player.inspecting = true;
      var Q = player.weapon.inspAnim;
      if (
        player.weapon.melee &&
        game.store.skins[player.meleeIndex] &&
        game.store.skins[player.meleeIndex].flipAnim
      ) {
        SOUND.play("melee_equip", 0.03, false, 1.7);
        if (Q) {
          Q.wpSp = Math.PI * 4;
        }
      } else if (Q) {
        Q.wpSp = 0;
      }
      if (Q && player.weapon.inspAnim) {
        player.inspectTween = new TWEEN.Tween(player.inspectAn)
          .to(Q, 400)
          .easing(TWEEN.Easing.Exponential.Out)
          .start();
      }
    }
  };
  // CANCEL INSPECT:
  this.cancelInspect = function (player) {
    if (player.inspectTween) {
      player.inspectTween.stop();
    }
    player.inspecting = false;
    player.inspectX = 0;
    player.inspectAn = {
      arZ: 0,
      arX: 0,
      arY: 0,
      apZ: 0,
      apX: 0,
      apY: 0,
      wpZ: 0,
      wpY: 0,
      wrY: 0,
      wpSp: 0,
    };
  };
  // SPRAY:
  this.spray = function (player) {
    if (!config.isComp && game.now - player.lastSpray >= config.sprayTimer) {
      var Q = game.sprays[0];
      if (game.sprays[player.sprayIndex]) {
        Q = game.sprays[player.sprayIndex];
      } else if (
        game.store.skins[player.sprayIndex] &&
        game.store.skins[player.sprayIndex].type == 4
      ) {
        Q = game.store.skins[player.sprayIndex];
      }
      L.length = 0;
      var R = 0;
      var S =
        1 / (config.sprayRange * Math.sin(player.yaw + Math.PI) * Math.cos(player.pitch));
      var T =
        1 / (config.sprayRange * Math.cos(player.yaw + Math.PI) * Math.cos(player.pitch));
      var U = 1 / (config.sprayRange * Math.sin(player.pitch));
      for (var V = 0; V < game.map.manager.objects.length; ++V) {
        if (
          !(G = game.map.manager.objects[V]).noShoot &&
          !G.noVis &&
          !!G.active
        ) {
          if (
            (R = UTILS.lineInRect(
              player.x,
              player.z,
              player.y + player.height - config.cameraHeight,
              S,
              T,
              U,
              G.x - G.width,
              G.z - G.length,
              G.y - G.height,
              G.x + G.width,
              G.z + G.length,
              G.y + G.height,
            )) &&
            R <= 1
          ) {
            L.push({
              obj: G,
              dst: R,
            });
          }
        }
      }
      if (L.length && (L.sort(UTILS.orderByDst), (G = L[0].obj))) {
        var W = config.sprayRange * L[0].dst - 0.1;
        var X = player.y + player.height - config.cameraHeight + W * Math.sin(player.pitch);
        var Y = player.x + W * Math.sin(player.yaw + Math.PI) * Math.cos(player.pitch);
        var Z = player.z + W * Math.cos(player.yaw + Math.PI) * Math.cos(player.pitch);
        var a0 = 0;
        var a1 = 0;
        if (X >= G.y + G.height) {
          a1 = -90;
        } else if (X <= G.y - G.height) {
          a1 = 90;
        } else if (Y <= G.x - G.width) {
          a0 = -90;
        } else if (Y >= G.x + G.width) {
          a0 = 90;
        } else if (Z <= G.z - G.length) {
          a0 = 180;
        }
        var a2 = (Q.sizeReq || config.sprayScale) / 2;
        if (a1) {
          if (G.width < a2 || G.length < a2) {
            return;
          }
          if (Z - a2 < G.z - G.length) {
            Z = G.z - G.length + a2;
          } else if (Z + a2 > G.z + G.length) {
            Z = G.z + G.length - a2;
          }
          if (Y - a2 < G.x - G.width) {
            Y = G.x - G.width + a2;
          } else if (Y + a2 > G.x + G.width) {
            Y = G.x + G.width - a2;
          }
        } else {
          if (G.height < a2) {
            return;
          }
          if (a0 == 90 || a0 == -90) {
            if (G.length < a2) {
              return;
            }
            if (Z - a2 < G.z - G.length) {
              Z = G.z - G.length + a2;
            } else if (Z + a2 > G.z + G.length) {
              Z = G.z + G.length - a2;
            }
          } else {
            if (G.width < a2) {
              return;
            }
            if (Y - a2 < G.x - G.width) {
              Y = G.x - G.width + a2;
            } else if (Y + a2 > G.x + G.width) {
              Y = G.x + G.width - a2;
            }
          }
          if (X + a2 > G.y + G.height) {
            X = G.y + G.height - a2;
          }
        }
        player.lastSpray = game.now;
        if (game.playSound) {
          game.playSound(
            config.networkSounds.indexOf("spray"),
            0.4,
            player.sid,
            player.x,
            player.y,
            player.z,
            true,
          );
        }
        window.IO.broadcast(
          "game" + game.sid,
          "sp",
          player.sid,
          player.sprayIndex,
          Y.round(2),
          X.round(2),
          Z.round(2),
          a0,
          a1,
        );
      }
    }
  };
  // MELEE:
  this.melee = function (player) {
    var Q = player.weapon.canThrow && player.aimVal <= 0.1 && player.canThrow;
    player.reloads[player.weaponIndex] = player.weapon.rate * (game.config.fiRat || 1);
    player.didShoot = true;
    player.didAct = true;
    var R = game.store.skins[player.meleeIndex] || {};
    if (player.isYou) {
      if (player.isYou && game.controls) {
        if (
          game.controls.cntrlInput.vibration &&
          game.controls.gamepad.active
        ) {
          game.controls.gamepad.rumble(
            player.weapon.rumbleDur || 200,
            player.weapon.rumble || 0.5,
          );
        } else if (
          game.controls.mblInput.vibration &&
          !game.controls.isMobile &&
          "vibrate" in navigator
        ) {
          navigator.vibrate(player.weapon.rumbleDur || 200);
        }
      }
      if (player.weapon.anim) {
        player.weapon.anim(player, TWEEN, player.canThrow ? (Q ? 3 : 1) : 2);
      }
      this.cancelInspect(player);
      if (player.canThrow) {
        SOUND.play(
          "swsh_" + ((R.snd && R.id) || 0) + "_" + UTILS.randInt(0, 1),
          0.1,
          false,
        );
      } else {
        SOUND.play("swsh_def_" + UTILS.randInt(0, 1), 0.1, false);
      }
    }
    var T = player.yaw;
    var U = player.pitch;
    var V = player.y + player.height - config.cameraHeight;
    if (Q) {
      player.canThrow = !!player.unlimitedAmmo;
      player.shotCntP++;
      var W = game.projectiles.stored[0];
      var X = player.meleeIndex;
      var Y = {
        wId: 12,
        w: game.weaponConfig[12],
      };
      if (IO) {
        game.projectiles.init(player.x, V, player.z, T, U, W, player, Y, true, X);
      } else {
        PARTICLES.physObj(
          player.x,
          V,
          player.z,
          T,
          U,
          3000,
          false,
          null,
          null,
          W,
          -1,
          player.shotCntP,
          X,
        );
      }
      if (player.isYou) {
        player.lastThrow = player.canThrow;
        var Z = document.getElementById("weapIconMel");
        if (Z) {
          Z.src = UTILS.assetsUrl("/textures/weapons/icon_0.png");
        }
      }
    } else {
      L.length = 0;
      var a0 = 0;
      var a1 = 1 / (player.weapon.range * Math.sin(T + Math.PI) * Math.cos(U));
      var a2 = 1 / (player.weapon.range * Math.cos(T + Math.PI) * Math.cos(U));
      var a3 = 1 / (player.weapon.range * Math.sin(U));
      if (IO) {
        for (var a4 = 0; a4 < game.map.manager.objects.length; ++a4) {
          if ((G = game.map.manager.objects[a4]).active && !G.noShoot) {
            if (
              (a0 = UTILS.lineInRect(
                player.x,
                player.z,
                V,
                a1,
                a2,
                a3,
                G.x - G.width,
                G.z - G.length,
                G.y - G.height,
                G.x + G.width,
                G.z + G.length,
                G.y + G.height,
              )) &&
              a0 <= 1
            ) {
              L.push({
                obj: G,
                dst: a0,
              });
            }
          }
        }
      }
      if (IO) {
        for (a4 = 0; a4 < this.list.length; ++a4) {
          if (
            this.list[a4].active &&
            player != this.list[a4] &&
            (!player.team || player.team != this.list[a4].team || game.mode.dmgTeam)
          ) {
            if ((G = this.fetchState(this.list[a4], player.getStateConst()))) {
              if (
                (a0 = UTILS.lineInRect(
                  player.x,
                  player.z,
                  V,
                  a1,
                  a2,
                  a3,
                  G.x - this.list[a4].scale - (game.mode.hitBoxPad || 1),
                  G.z - this.list[a4].scale - (game.mode.hitBoxPad || 1),
                  G.y,
                  G.x + this.list[a4].scale + (game.mode.hitBoxPad || 1),
                  G.z + this.list[a4].scale + (game.mode.hitBoxPad || 1),
                  G.y + G.h + (game.mode.hitBoxPad || 1),
                )) &&
                a0 <= 1
              ) {
                L.push({
                  player: true,
                  obj: this.list[a4],
                  dst: a0,
                });
              }
            }
          }
        }
      }
      if (IO) {
        for (a4 = 0; a4 < game.AI.ais.length; ++a4) {
          if (game.AI.ais[a4].active) {
            G = game.AI.ais[a4];
            if (
              (a0 = UTILS.lineInRect(
                player.x,
                player.z,
                V,
                a1,
                a2,
                a3,
                G.x - G.scale,
                G.z - G.scale,
                G.y,
                G.x + G.scale,
                G.z + G.scale,
                G.y + G.scale * 2,
              )) &&
              a0 <= 1
            ) {
              L.push({
                ai: true,
                obj: game.AI.ais[a4],
                dst: a0,
              });
            }
          }
        }
      }
      player.weapon.range;
      if (L.length) {
        L.sort(UTILS.orderByDst);
        var a5 = player.weapon.dmg;
        if (!player.canThrow) {
          a5 = 35;
        }
        if (player.smite) {
          a5 = 10000;
        }
        for (
          a4 = 0;
          a4 < L.length &&
          ((G = L[a4]), player.weapon.range * G.dst, IO) &&
          (false,
          G.obj && G.ai
            ? !game.waitTimers &&
              (G.obj.changeHealth(-a5, player),
              !G.obj.active &&
                G.obj.killScore &&
                this.score(player, G.obj.killScore, true),
              IO.send(
                player.id,
                "4",
                G.obj.sid,
                Math.round(a5),
                0,
                !G.obj.active,
                1,
              ))
            : !game.waitTimers &&
              G.obj &&
              G.obj.health &&
              !G.player &&
              (IO.send(player.id, "4"),
              (G.obj.health -= a5),
              G.obj.health <= 0 &&
                ((G.obj.active = false),
                (G.obj.health = 0),
                (G.obj.destroyedBy = player),
                (G.obj.destroyed = true),
                game.map.manager.destObjs.push(G.obj.uid),
                window.IO.broadcast("game" + game.sid, "do", G.obj.uid),
                G.obj && G.obj.onDestroy && game.onTrigger(player, G.obj))),
          IO &&
            game.mode.teamOptions &&
            game.mode.teamOptions[player.team - 1] == "Seekers" &&
            !G.player &&
            G.obj &&
            G.obj.propID &&
            this.changeHealth(player, null, 10) &&
            this.kill(player, null, {}),
          G.obj &&
            (G.obj.onMelee ||
              G.obj.onDamage ||
              (!player.canThrow && G.obj.onPunch)) &&
            game.onTrigger(player, G.obj),
          G.obj && G.obj.isEvent && game.foundEventItem(player, G.obj),
          G.player || (G.obj && G.obj.dummy)) &&
          (game.mode &&
            game.mode.onMelee &&
            game.mode.onMelee(game, player, G.obj) &&
            (a5 = G.obj.health || a5),
          this.changeHealth(G.obj, player, a5) &&
            (player &&
              (player.canThrow
                ? (player.melees++, IO && game.incStat("mk", player))
                : !player.canThrow && (player.fistKills++, IO && game.incStat("fk", player))),
            this.kill(G.obj, player, {
              wId: player.weapon.id,
              w: player.weapon,
              fs: !player.canThrow,
            })),
          !(
            (a5 -=
              player.weapon.pierce == null
                ? a5
                : player.weapon.dmg * config.materialDens.flesh * player.weapon.pierce) <=
            0
          ));
          ++a4
        );
      }
    }
  };
  var L = [];
  // SHOOT:
  this.shoot = function (player, a1, a2) {
    var a3 = false;
    if (IO) {
      game.incStat("s", player);
    }
    if (!player.unlimitedAmmo) {
      player.ammos[player.weaponIndex]--;
    }
    player.didShoot = true;
    player.didAct = true;
    if (player.burstCount) {
      player.burstCount--;
    } else {
      player.burstCount = player.weapon.burst ? player.weapon.burst.c - 1 : 0;
    }
    player.reloads[player.weaponIndex] =
      (player.burstCount && player.weapon.burst
        ? player.weapon.burst.r
        : player.weapon.rate) * (game.config.fiRat || 1);
    this.updatePlayerAmmo(player);
    var a4 = game.store.skins[player.skins[player.weaponIndex]];
    if (!a4 && player.weapon.altSkin != null) {
      a4 = player.weapon.altSkin;
    }
    if (a4 && a4.weapon - 1 != player.loadout[player.weaponIndex]) {
      a4 = {};
    }
    if (game.playSound) {
      var a5 = config.networkSounds.indexOf(
        player.weapon.sound + (a4 && a4.mid != null ? "_" + a4.mid : ""),
      );
      game.playSound(
        a5,
        0.85,
        player.sid,
        player.x,
        player.y,
        player.z,
        false,
        UTILS.randFloat(0.9, 1.1),
      );
    }
    player.recoilForce += player.weapon.recoil;
    if (player.isYou && game.controls) {
      if (game.controls.cntrlInput.vibration && game.controls.gamepad.active) {
        game.controls.gamepad.rumble(
          player.weapon.rumbleDur || 200,
          player.weapon.rumble || 0.5,
        );
      } else if (
        game.controls.mblInput.vibration &&
        !game.controls.isMobile &&
        "vibrate" in navigator
      ) {
        navigator.vibrate(player.weapon.rumbleDur || 200);
      }
    }
    var a6 = !game.map.config || game.map.config.mdl !== 2;
    if (player.renderYou && a6) {
      var a7 = UTILS.randFloat(-Math.PI, Math.PI);
      player.recoilX += player.weapon.recoilR * Math.sin(a7);
      player.recoilZ += player.weapon.recoilR * 0.3 * Math.cos(a7);
      if (player.recoilTween) {
        player.recoilTween.stop();
      }
      var a8 =
        ((player.weapon.recoilAnim && player.weapon.recoilAnim.time) ||
          player.weapon.rate) * (game.config.fiRat || 1);
      if (
        player.aimVal == 0 &&
        player.weapon.recoilAnim &&
        player.weapon.recoilAnim.aimTime
      ) {
        a8 = player.weapon.recoilAnim.aimTime;
      }
      player.recoilTween = new TWEEN.Tween(player)
        .to(player.weapon.recoilAnim || {}, a8 * 0.15)
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(function () {
          player.recoilTween = new TWEEN.Tween(player)
            .to(
              {
                recoilTweenY: 0,
                recoilTweenR: 0,
                recoilTweenYM: 0,
                recoilTweenZ: 0,
              },
              a8 * 0.95,
            )
            .easing(TWEEN.Easing.Back.Out)
            .start();
        })
        .start();
      this.cancelInspect(player);
    }
    if (
      player.renderYou &&
      a6 &&
      !this.isWeaponHidden(player, player.weaponIndex)
    ) {
      var a9 = player.weaponMeshes[player.weaponIndex];
      var aa = player.aimVal == 0 && player.weapon.scope;
      if (
        PARTICLES.showMuzzle &&
        !player.weapon.nMuz &&
        (!a4 || !a4.noMuz) &&
        !game.controls.camOffset
      ) {
        for (var ab = 0; ab < a9.muzzles.length; ++ab) {
          a9.muzzles[ab].visible = true;
          PARTICLES.setMaterial(
            a9.muzzles[ab],
            player.weapon.muzID || 2,
            1,
            true,
          );
          I.siz = (player.weapon.muzMlt || 1) * 4;
          I.static = true;
          I.life = 1;
          a9.muzzles[ab].init(
            ab ? player.weapon.xOff * -2 * (player.leftHand ? -1 : 1) : 0,
            player.weapon.muzOffY || 0,
            -player.weapon.muzOff,
            I,
          );
        }
        if (!aa) {
          (aQ = player.weaponMeshes[player.weaponIndex].muzzles[0]
            .getWorldPosition()
            .clone()).project(RENDER.camera);
          aQ.x = (aQ.x + 1) / 2;
          aQ.y = (aQ.y + 1) / 2;
          RENDER.flash(aQ.x, aQ.y);
        }
      }
      if (!player.weapon.nCase && PARTICLES.active) {
        for (
          ab = 0;
          ab < player.weaponMeshes[player.weaponIndex].casings.length;
          ++ab
        ) {
          aQ =
            player.weaponMeshes[player.weaponIndex].casings[
              ab
            ].getWorldPosition();
          if (SOUND && game.now - (player.lastShell || 0) > 400) {
            player.lastShell = game.now;
            SOUND.play(
              "case_" + UTILS.randInt(0, 1),
              0.45,
              false,
              UTILS.randFloat(0.8, 1.3),
            );
          }
          if (!aa) {
            var ac = UTILS.randInt(0, 1) ? 1.4 : 0.8;
            PARTICLES.physObj(
              aQ.x,
              aQ.y,
              aQ.z,
              player.yaw - (Math.PI / 2) * (ab ? -1 : 1),
              (Math.PI / 5) * UTILS.randFloat(0.75, 1.2) * ac,
              25,
              false,
              player.weapon.caseInd || 1,
              player,
            );
          }
        }
      }
    }
    if (!player.renderYou || PARTICLES.yourTrails || player.weapon.physPow) {
      var ad = player.y + player.height - config.cameraHeight;
      var af =
        player.weapon.projectile != null &&
        (!player.weapon.projectile.disable || game.config.bDrop);
      if (af) {
        player.shotCntP++;
        var ag =
          config.projSpreads[player.shotCntP % config.projSpreads.length];
        var ah =
          (player.spread + (player.weapon.innac || 0)) * config.spreadAdj;
        ah *= ag;
        var ai = player.yaw + ah;
        var aj = player.pitch + player.recoilAnimY * config.recoilMlt + ah;
        if (IO) {
          var ak = {
            wId: a2,
            w: game.weaponConfig[a2],
          };
          game.projectiles.init(
            player.x,
            ad,
            player.z,
            ai,
            aj,
            player.weapon.projectile,
            player,
            ak,
          );
        }
        if (player.isYou && !player.weapon.projectile.dontPred) {
          PARTICLES.physObj(
            player.x,
            ad,
            player.z,
            ai,
            aj,
            3000,
            false,
            null,
            null,
            player.weapon.projectile,
            -1,
            player.shotCntP,
          );
        }
      }
      if (!af || player.weapon.physPow) {
        var al = 0;
        for (
          var am = player.weapon.physPow ? -1 : 0;
          am < (player.weapon.shots == null ? 1 : player.weapon.shots);
          ++am
        ) {
          ai = 0;
          aj = 0;
          if (player.weapon.cSpread && am >= 0) {
            var an = UTILS.randFloat(0.3, 0.32);
            var ao =
              player.ammos[player.weaponIndex] * (player.weapon.shots * 2);
            ai = player.yaw + player.weapon.cSpread[ao + al] * an;
            aj = player.pitch + player.weapon.cSpread[ao + al + 1] * an;
            al += 2;
          } else {
            ah =
              am >= 0
                ? (player.spread + (player.weapon.innac || 0)) *
                  config.spreadAdj
                : 0;
            ai = player.yaw + UTILS.randFloat(-ah, ah);
            aj = player.pitch + UTILS.randFloat(-ah, ah);
          }
          aj += player.recoilAnimY * config.recoilMlt;
          var weapRange = player.weapon.range;
          if (am < 0) {
            weapRange = player.weapon.physRang;
          }
          L.length = 0;
          var aq = 0;
          var ar = 1 / (weapRange * Math.sin(ai + Math.PI) * Math.cos(aj));
          var as = 1 / (weapRange * Math.cos(ai + Math.PI) * Math.cos(aj));
          var at = 1 / (weapRange * Math.sin(aj));
          for (var au = 0; au < game.map.manager.objects.length; ++au) {
            if ((G = game.map.manager.objects[au]).active && !G.noShoot) {
              if (
                (aq = UTILS.lineInRect(
                  player.x,
                  player.z,
                  ad,
                  ar,
                  as,
                  at,
                  G.x - G.width,
                  G.z - G.length,
                  G.y - G.height,
                  G.x + G.width,
                  G.z + G.length,
                  G.y + G.height,
                )) &&
                aq <= 1
              ) {
                L.push({
                  obj: G,
                  dst: aq,
                });
              }
            }
          }
          if (IO && am >= 0) {
            for (au = 0; au < this.list.length; ++au) {
              if (
                this.list[au].active &&
                player != this.list[au] &&
                (!player.team ||
                  player.team != this.list[au].team ||
                  game.mode.dmgTeam)
              ) {
                if (
                  (G = this.fetchState(this.list[au], player.getStateConst()))
                ) {
                  if (
                    (aq = UTILS.lineInRect(
                      player.x,
                      player.z,
                      ad,
                      ar,
                      as,
                      at,
                      G.x - this.list[au].scale - (game.mode.hitBoxPad || 1),
                      G.z - this.list[au].scale - (game.mode.hitBoxPad || 1),
                      G.y,
                      G.x + this.list[au].scale + (game.mode.hitBoxPad || 1),
                      G.z + this.list[au].scale + (game.mode.hitBoxPad || 1),
                      G.y + G.h + (game.mode.hitBoxPad || 1),
                    )) &&
                    aq <= 1
                  ) {
                    L.push({
                      player: true,
                      obj: this.list[au],
                      dst: aq,
                    });
                  }
                }
              }
            }
          }
          if (IO && am >= 0) {
            for (au = 0; au < game.AI.ais.length; ++au) {
              if (game.AI.ais[au].active) {
                G = game.AI.ais[au];
                if (
                  (aq = UTILS.lineInRect(
                    player.x,
                    player.z,
                    ad,
                    ar,
                    as,
                    at,
                    G.x - G.scale,
                    G.z - G.scale,
                    G.y,
                    G.x + G.scale,
                    G.z + G.scale,
                    G.y + G.scale * 2,
                  )) &&
                  aq <= 1
                ) {
                  L.push({
                    ai: true,
                    obj: game.AI.ais[au],
                    dst: aq,
                  });
                }
              }
            }
          }
          var terrain = game.map.terrain;
          if (terrain) {
            var aw = terrain.raycast(
              player.x,
              -player.z,
              ad,
              1 / ar,
              -1 / as,
              1 / at,
            );
            if (aw) {
              let dst = UTILS.getD3D(player.x, ad, player.z, aw.x, aw.z, -aw.y);
              L.push({
                terrain: true,
                dst: dst / weapRange,
              });
            }
          }
          var tmpRange = weapRange;
          if (L.length) {
            L.sort(UTILS.orderByDst);
            var ay = player.weapon.dmg;
            if (player.smite) {
              ay = 10000;
            }
            var az = false;
            for (au = 0; au < L.length; ++au) {
              tmpRange = weapRange * (G = L[au]).dst;
              if (am < 0) {
                var aA =
                  (1 - G.dst) *
                  (player.weapon.physPow *
                    (game.config ? game.config.impulseMlt : 1));
                var aB = aA * Math.sin(ai + Math.PI) * Math.cos(aj);
                player.velX -= aB;
                var aC = aA * Math.cos(ai + Math.PI) * Math.cos(aj);
                player.velZ -= aC;
                var aD = aA * Math.sin(aj);
                player.velY -= aD;
                player.onGround = false;
                if (!IO) {
                  a1.velObj = {
                    x: aB,
                    y: aC,
                    z: aD,
                  };
                }
                break;
              }
              if (!IO) {
                break;
              }
              var aE = player.weapon.dropStart || 0;
              var aF = Math.min(
                1,
                1 - ((1 - G.dst) * weapRange) / (weapRange - aE),
              );
              var aG = ay - player.weapon.dmgDrop * aF;
              var aH = false;
              var aI = false;
              if (G.player) {
                var aJ = ad + tmpRange * Math.sin(aj);
                aH = G.obj.y + G.obj.height - aJ < config.headScale;
                aI = G.obj.y + config.legHeight > aJ;
                aG *=
                  aH && !player.weapon.noHeadShot
                    ? player.weapon.hsMlt || 1.5
                    : 1;
                aG *= aI ? 0.5 : 1;
                if (!aH && !!game.config && !!game.config.headshotOnly) {
                  aG = 0;
                }
              }
              if (IO && G.obj && G.ai) {
                G.obj.changeHealth(-aG, player);
                if (!G.obj.active && G.obj.killScore) {
                  this.score(player, G.obj.killScore, true);
                }
                IO.send(
                  player.id,
                  "4",
                  G.obj.sid,
                  Math.round(aG),
                  0,
                  !G.obj.active,
                  1,
                );
              } else if (
                IO &&
                !game.waitTimers &&
                G.obj &&
                G.obj.health &&
                !G.player
              ) {
                G.obj.health -= aG;
                IO.send(player.id, "4");
                if (G.obj.health <= 0) {
                  G.obj.active = false;
                  G.obj.health = 0;
                  G.obj.destroyed = true;
                  G.obj.destroyedBy = player;
                  game.map.manager.destObjs.push(G.obj.uid);
                  window.IO.broadcast("game" + game.sid, "do", G.obj.uid);
                  if (G.obj && G.obj.onDestroy) {
                    game.onTrigger(player, G.obj);
                  }
                }
              } else if (
                IO &&
                game.mode.teamOptions &&
                game.mode.teamOptions[player.team - 1] == "Seekers" &&
                !G.player &&
                G.obj &&
                G.obj.propID &&
                this.changeHealth(player, null, 10)
              ) {
                this.kill(player, null, {});
              }
              if (G.obj && (G.obj.onShoot || G.obj.onDamage)) {
                game.onTrigger(player, G.obj);
              }
              if (G.obj && G.obj.isEvent) {
                game.foundEventItem(player, G.obj);
              }
              if (G.player) {
                a3 = true;
                if (this.changeHealth(G.obj, player, aG, null, aH)) {
                  if (az) {
                    player.wallbangs++;
                    if (IO) {
                      game.incStat("wb", player);
                    }
                  }
                  if (aH) {
                    player.headshots++;
                    if (IO) {
                      game.incStat("hs", player);
                    }
                  }
                  this.kill(G.obj, player, {
                    dst: G.dst,
                    hs: aH,
                    wb: az,
                    wId: a2,
                    w: game.weaponConfig[a2],
                  });
                }
                ay -=
                  player.weapon.pierce == null
                    ? ay
                    : player.weapon.dmg *
                      config.materialDens.flesh *
                      player.weapon.pierce;
              } else if (G.obj && G.obj.penetrable) {
                az = true;
                ay -=
                  player.weapon.pierce == null
                    ? ay
                    : player.weapon.dmg *
                      config.materialDens.default *
                      player.weapon.pierce;
              } else {
                if (!G.ai || !G.obj) {
                  break;
                }
                ay -=
                  player.weapon.pierce == null
                    ? ay
                    : player.weapon.dmg *
                      config.materialDens.default *
                      player.weapon.pierce;
              }
              if (ay <= 0) {
                break;
              }
            }
          }
          if (!(am < 0)) {
            tmpRange -= 0.12;
            var aK =
              player.x + tmpRange * Math.sin(ai + Math.PI) * Math.cos(aj);
            aJ = ad + tmpRange * Math.sin(aj);
            var aL =
              player.z + tmpRange * Math.cos(ai + Math.PI) * Math.cos(aj);
            var aM = 0;
            var aN = 0;
            if (L.length) {
              if (G.terrain || aJ >= G.obj.y + G.obj.height) {
                aN = Math.PI / 2;
              } else if (aJ <= G.obj.y - G.obj.height) {
                aN = -Math.PI / 2;
              } else if (aK <= G.obj.x - G.obj.width) {
                aM = -Math.PI / 2;
              } else if (aK >= G.obj.x + G.obj.width) {
                aM = Math.PI / 2;
              } else if (aL <= G.obj.z - G.obj.length) {
                aM = Math.PI;
              }
              if (!IO) {
                PARTICLES.effect(aK, aJ, aL, aM, aN, 0);
              }
            }
            if (IO) {
              var aO = player.weapon && player.weapon.trail ? 1 : 0;
              for (au = 0; au < this.list.length; ++au) {
                if (
                  (this.list[au].active || this.list[au].spectating) &&
                  this.list[au] != player
                ) {
                  if (!L.length || G.player || G.ai) {
                    IO.send(this.list[au].id, "9", [
                      player.sid,
                      Math.round(aK),
                      Math.round(aJ),
                      Math.round(aL),
                      undefined,
                      undefined,
                      aO,
                      player.x.round(1),
                      player.y.round(1),
                      player.height.round(1),
                      player.z.round(1),
                    ]);
                  } else {
                    IO.send(this.list[au].id, "9", [
                      player.sid,
                      Math.round(aK),
                      Math.round(aJ),
                      Math.round(aL),
                      aM.round(1),
                      aN.round(1),
                      aO,
                      player.x.round(1),
                      player.y.round(1),
                      player.height.round(1),
                      player.z.round(1),
                    ]);
                  }
                }
              }
            }
            if (
              player.isYou &&
              tmpRange >= config.tracerMinDst &&
              PARTICLES.showTracers
            ) {
              if (a6) {
                var aP = UTILS.randInt(
                  0,
                  player.weaponMeshes[player.weaponIndex].muzzles.length - 1,
                );
                var aQ =
                  player.weaponMeshes[player.weaponIndex].muzzles[
                    aP
                  ].getWorldPosition();
              } else {
                (aQ = player.objInstances.getWorldPosition()).y +=
                  player.height / 2;
              }
              var aR =
                player.weapon && player.weapon.scope && player.aimVal == 0
                  ? 7
                  : 0;
              var aS = aQ.x - aR * Math.sin(ai + Math.PI) * Math.cos(aj);
              var aT = aQ.y - aR * Math.sin(aj);
              var aU = aQ.z - aR * Math.cos(ai + Math.PI) * Math.cos(aj);
              UTILS.getD3D(aS, aT, aU, aK, aJ, aL);
              aM = UTILS.direction2D(aU, aS, aL, aK);
              aN = UTILS.direction2D(
                UTILS.distance2D(aS, aU, aK, aL),
                aJ,
                0,
                aT,
              );
              PARTICLES.physObj(
                aS,
                aT,
                aU,
                aM,
                aN,
                Math.min(tmpRange + aR, config.tracerMaxDst),
                player.weapon && player.weapon.trail,
                0,
                player,
              );
            }
          }
        }
      }
      if (a3 && IO) {
        game.incStat("h", player);
      }
    }
  };
  // INTERACT:
  this.interact = function (player, Q) {
    if (game.now - player.lastInteract >= config.interactTimer) {
      player.lastInteract = game.now;
      if (!Q) {
        if (
          (!game.mode.teamOptions ||
            game.mode.teamOptions[player.team - 1] != "Infected") &&
          (!game.mode || !game.mode.noPickups)
        ) {
          for (var R = 0; R < game.map.manager.pickups.length; ++R) {
            if (
              (F = game.map.manager.pickups[R]).active &&
              F.pickup != null &&
              player.collides(F) &&
              player.loadout.indexOf(F.pickup) == -1 &&
              (!F.team || !game.mode || !game.mode.teams || F.team == player.team) &&
              (game.weaponConfig[F.pickup].type != 3 ||
                (game.mode && game.mode.site)) &&
              player.score >= F.scoreP
            ) {
              var S = game.weaponConfig[F.pickup].type;
              if (S == 3 && (!game.mode || !game.mode.site)) {
                continue;
              }
              var T = false;
              G = undefined;
              for (var U = 0; U < player.loadout.length; U++) {
                if (game.weaponConfig[player.loadout[U]].type == S) {
                  G = player.loadout[U];
                  var V = this.removePicked(player, player.loadout[0]);
                  if (F.pickupRep && V) {
                    this.addPicked(player, F.pickup, F.uid);
                  }
                  player.loadout[U] = F.pickup;
                  player.weaponIndex = U;
                  if (F.pickupRep) {
                    F.pickup = G;
                  }
                  T = true;
                  break;
                }
              }
              if (!T) {
                G = undefined;
                if (F.pickupRep) {
                  this.addPicked(player, F.pickup, F.uid);
                }
                player.loadout.push(F.pickup);
                player.loadout.sort(function (W, X) {
                  return (
                    game.weaponConfig[W || 0].type -
                    game.weaponConfig[X || 0].type
                  );
                });
                player.weaponIndex = player.loadout.indexOf(F.pickup);
                if (F.pickupRep) {
                  F.pickup = undefined;
                }
              }
              window.IO.broadcast(
                "game" + game.sid,
                "inat",
                player.sid,
                player.loadout,
                player.weaponIndex,
                F.uid,
                F.pickupRep ? G : F.pickup,
                !!F.active,
              );
              player.updateLoadout(game, player.weaponIndex, true, ...player.loadout);
              if (F.scoreP != 0 && !F.method) {
                IO.send(player.id, "am", ["Purchased", null]);
                this.score(player, -F.scoreP);
              }
              break;
            }
          }
        }
        if (
          !game.waitTimers ||
          (game.waitTimers[0] && game.waitTimers[0].contTime)
        ) {
          for (R = 0; R < game.map.manager.gates.length; ++R) {
            if (
              ((F = game.map.manager.gates[R]).active || F.closeable) &&
              player.collides(F, F.tRadius) &&
              (!F.team || !game.mode || !game.mode.teams || F.team == player.team) &&
              ((player.score >= F.scoreP && F.method < 2) ||
                (player.kills >= F.scoreP && F.method == 2))
            ) {
              if (F.scoreP != 0) {
                IO.send(player.id, "am", [
                  F.method ? "Unlocked" : "Purchased",
                  null,
                ]);
                if (!F.method) {
                  this.score(player, -F.scoreP);
                }
              }
              F.active = !F.active;
              window.IO.broadcast("game" + game.sid, "gte", F.uid, F.active);
              break;
            }
          }
        }
        for (R = 0; R < game.map.manager.terminals.length; ++R) {
          if (
            (F = game.map.manager.terminals[R]).active &&
            player.collides(F, F.tRadius) &&
            (!F.team || !game.mode || !game.mode.teams || F.team == player.team)
          ) {
            IO.send(player.id, "ot", F.uid);
          }
        }
      }
      for (R = 0; R < game.map.manager.banks.length; ++R) {
        if (
          (F = game.map.manager.banks[R]).active &&
          player.collides(F, F.tRadius) &&
          (!F.team || !game.mode || !game.mode.teams || F.team == player.team)
        ) {
          if (F.deposited != 0 && Q) {
            if (F.withdrawAmnt && F.deposited > F.withdrawAmnt) {
              F.deposited -= F.withdrawAmnt;
              this.score(player, F.withdrawAmnt);
            } else {
              this.score(player, F.deposited);
              F.deposited = 0;
            }
          } else if (player.score != 0 && !Q) {
            if (F.depositAmnt && player.score > F.depositAmnt) {
              F.deposited += F.depositAmnt;
              this.score(player, -F.depositAmnt);
            } else {
              F.deposited += player.score;
              this.score(player, -player.score);
            }
          }
          window.IO.broadcast("game" + game.sid, "bnk", F.uid, F.deposited);
          break;
        }
      }
    }
  };
  this.findEmptyPickup = function (P, Q) {
    var R;
    for (var S = 0; S < game.map.manager.pickups.length; ++S) {
      if (
        (R = game.map.manager.pickups[S]).pickupRep &&
        R.pickup == null &&
        P == R.uid
      ) {
        if (Q) {
          return R;
        } else {
          return R.uid;
        }
      }
    }
    return null;
  };
  this.addPicked = function (player, Q, R) {
    if (player.lastPicked[Q] == null) {
      player.lastPicked[Q] = R;
    }
  };
  this.removePicked = function (player, Q) {
    var R = player.lastPicked[Q];
    if (R != null) {
      delete player.lastPicked[Q];
    }
    return R != null;
  };
  this.dropWeapon = function (player, Q, R, S = true) {
    if (
      IO &&
      (!game.mode || !game.mode.noPickups) &&
      game.map.manager.pickups.length
    ) {
      var T = null;
      if (R) {
        if ((T = player.loadout.indexOf(R)) == -1) {
          return;
        }
      } else {
        T = player.weaponIndex;
      }
      var U;
      var V = player.loadout[T];
      var W = [player.x + UTILS.randInt(-1, 1), player.y + 1, player.z + UTILS.randInt(-1, 1)];
      if (Q) {
        if (game.mode && game.mode.site) {
          return;
        }
        for (var X = 0; X < player.loadout.length; X++) {
          V = player.loadout[X];
          if (player.lastPicked[V] != null) {
            if (
              (U = this.findEmptyPickup(player.lastPicked[V])) &&
              !game.weaponConfig[V].melee
            ) {
              W = [
                player.x + UTILS.randInt(-5, 5),
                player.y + 1,
                player.z + UTILS.randInt(-5, 5),
              ];
              game.updatePickup(U, V, null, S, W);
              window.IO.broadcast(
                "game" + game.sid,
                "inat",
                -1,
                null,
                null,
                U,
                V,
                true,
                W,
              );
            }
          }
        }
        player.lastPicked = {};
      } else if (!game.weaponConfig[V].melee) {
        if (
          (game.mode && game.mode.site && !game.weaponConfig[V].equipment) ||
          player.lastPicked[V] == null
        ) {
          return undefined;
        } else {
          if ((U = this.findEmptyPickup(player.lastPicked[V], true))) {
            this.removePicked(player, V);
            game.updatePickup(U.uid, V, null, S, W);
          }
          player.loadout.splice(T, 1);
          player.loadout.sort(function (Y, Z) {
            return (
              game.weaponConfig[Y || 0].type - game.weaponConfig[Z || 0].type
            );
          });
          player.weaponIndex = 0;
          window.IO.broadcast(
            "game" + game.sid,
            "inat",
            player.sid,
            player.loadout,
            player.weaponIndex,
            U ? U.uid : null,
            V,
            !!U && U.uid,
            S,
            W,
          );
          player.updateLoadout(game, player.weaponIndex, true, ...player.loadout);
          return U || null;
        }
      }
    }
  };
  var M = "";
  var N = {};
  this.clearInteract = function (player) {
    if (player.isYou) {
      N.active = false;
      N.type = null;
      N.data = null;
      N.priority = 0;
    }
  };
  this.changeInteract = function (player, Q, R, S) {
    if (player.isYou) {
      N.enabled = true;
      N.active = true;
      if ((S == null && Q != N.type) || (S || 0) > (N.priority || 0)) {
        N.priority = S;
        N.type = Q;
        N.data = R;
      }
    }
  };
  this.updateInteract = function (player) {
    if (N.enabled && player.isYou) {
      if (N.active) {
        if (N.type == 0) {
          M =
            'Press <span style="color:' +
            COLORS.interactPopup.key +
            '">[' +
            UTILS.getKeyName(game.controls.binds.interactKey.val) +
            "]</span> to " +
            (!N.data.active && N.data.closeable ? "Close" : "Open") +
            " gate" +
            (N.data.scoreP == 0
              ? ""
              : " <span style='color:" +
                (player.score >= N.data.scoreP
                  ? COLORS.interactPopup.enough
                  : COLORS.interactPopup.notEnough) +
                "'>[" +
                (N.data.scoreP || 0) +
                "]</span>" +
                (N.data.method == 2 ? " Kills" : ""));
        } else if (N.type == 1) {
          M =
            "<span style='color:" +
            COLORS.interactPopup.notEnough +
            "'>[" +
            UTILS.commaFormatNum(N.data.deposited || 0) +
            "]</span><div style='color: #fff;margin-top:-30px;'>Press <span style='color:" +
            COLORS.interactPopup.key +
            "'>[" +
            UTILS.getKeyName(game.controls.binds.interactKey.val) +
            "]</span> to Deposit - " +
            (N.data.depositAmnt || "All") +
            "</div><div style='color: #fff;margin-top:-30px;'>Press <span style='color:" +
            COLORS.interactPopup.key +
            "'>[" +
            UTILS.getKeyName(game.controls.binds.interactSecKey.val) +
            "]</span> to Withdraw - " +
            (N.data.withdrawAmnt || "All") +
            "</div>";
        } else if (N.type == 2) {
          M =
            'Press <span style="color:' +
            COLORS.interactPopup.key +
            '">[' +
            UTILS.getKeyName(game.controls.binds.interactKey.val) +
            "]</span> to Open Terminal";
        } else if (N.type == 3) {
          M = 'Press <span style="color:' + COLORS.interactPopup.key + '">';
          if (N.data == 1) {
            M += "[" + UTILS.getKeyName(10001) + "]</span> to Plant";
          } else if (N.data == 2) {
            M +=
              "[" +
              UTILS.getKeyName(game.controls.binds.equipKey.val) +
              "]</span> to Equip Bomb";
          } else if (N.data == 3) {
            M += "[" + UTILS.getKeyName(10001) + "]</span> to Diffuse";
          }
        } else if (N.type == 4) {
          M =
            'Press <span style="color:' +
            COLORS.interactPopup.key +
            '">[' +
            UTILS.getKeyName(10001) +
            "]</span> to Interact";
        } else if (N.type == 5) {
          M =
            'Press <span style="color:' +
            COLORS.interactPopup.key +
            '">[' +
            UTILS.getKeyName(game.controls.binds.interactKey.val) +
            "]</span> to Trade with <span style='color:#9eeb56'>[" +
            (N.data.fakeName ||
              (N.data.premiumT ? N.data.alias : N.data.name)) +
            "]</span>";
        } else if (N.type == 6) {
          M =
            'Press <span style="color:' +
            COLORS.interactPopup.key +
            '">[' +
            UTILS.getKeyName(game.controls.binds.interactKey.val) +
            "]</span> to pickup " +
            game.weaponConfig[N.data.pickup].name +
            (N.data.scoreP == 0
              ? ""
              : " <span style='color:" +
                (player.score >= N.data.scoreP
                  ? COLORS.interactPopup.enough
                  : COLORS.interactPopup.notEnough) +
                "'>[" +
                (N.data.scoreP || 0) +
                "]</span>");
        }
        if (interactMsg.innerHTML != M) {
          interactMsg.innerHTML = M;
        }
      }
      if (!N.active && interactMsg.innerHTML != "") {
        interactMsg.innerHTML = "";
      }
      var Q = N.active ? "block" : "none";
      if (interactMsg.style.display != Q) {
        interactMsg.style.display = Q;
      }
    }
  };
  var O = [];
  // SYNC LEADERBOARD:
  this.syncLeaders = function (P, Q) {
    if (P) {
      var R = game.mode.leaderStat || "score";
      H = game.mode.killSort
        ? this.list.slice().sort(UTILS.orderByKills)
        : this.list.slice().sort(UTILS.orderByScore);
      for (var S = 0; S < game.players.list.length; S++) {
        O.length = 0;
        var T = 0;
        if (Q == null || Q == game.players.list[S].id) {
          for (var U = 0; U < H.length; ++U) {
            if (!H[U].spectating) {
              if (T < 16) {
                T++;
                O.push(
                  H[U].sid,
                  game.mode.killSort
                    ? H[U].kills
                    : config.endForm[R]
                      ? config.endForm[R](H[U][R], game, H[U])
                      : H[U][R],
                );
              }
            }
          }
          IO.send(game.players.list[S].id, "7", O);
        }
      }
      game.leadersUpdated = false;
    } else {
      game.leadersUpdated = true;
    }
  };
  this.teamScore = function (player, Q) {
    if (game.teams[player.team]) {
      game.teams[player.team] += Q;
    } else {
      game.teams[player.team] = Q;
    }
    if (game.teamScoreUpd.indexOf(player.team) < 0) {
      game.teamScoreUpd.push(player.team);
    }
  };
  this.saveClassScores = function (player) {
    var Q;
    if (player.classScores) {
      for (var R = 0; R < game.config.classes.length; ++R) {
        Q = game.config.classes[R];
        if (player.classScores[Q]) {
          if (!player.account.stats["c" + Q]) {
            player.account.stats["c" + Q] = 0;
          }
          player.account.stats["c" + Q] += player.classScores[Q];
        }
      }
    }
  };
  // SCORE:
  this.score = function (player, Q, R, S) {
    if (IO) {
      if (S) {
        player.score = Q;
      } else if (!R || !game.mode.noScoreK) {
        player.score += Q;
      }
      if (game.host == null && player.score > 13000) {
        player.score = 13000;
        Q = 0;
      }
      if (game.mode.objective && !R) {
        player.objectiveScore += Q;
      }
      if (!S) {
        IO.send(player.id, "5", Q);
        for (var T = 0; T < this.list.length; ++T) {
          if (this.list[T].specStream == player.sid) {
            IO.send(this.list[T].id, "5", Q, 1);
          }
        }
      }
      this.syncLeaders();
      if (game.host == null) {
        if (!player.classScores[player.classIndex]) {
          player.classScores[player.classIndex] = 0;
        }
        player.classScores[player.classIndex] += Q;
      }
      if (
        game.mode.teams &&
        player.team &&
        game.teams &&
        !game.mode.noScoreC &&
        (!R || !game.mode.objective)
      ) {
        this.teamScore(player, Q);
      }
    }
  };
  // TICK PLAYER:
  this.tickPlayer = function (player, Q) {
    player.playTime += Q;
    if (player.hitTimer > 0) {
      player.hitTimer -= Q;
    }
    player.ticker -= Q;
    if (player.ticker <= 0) {
      player.ticker = 500;
      if (player.hitTimer <= 0 && !player.challMode) {
        this.changeHealth(player, null, -player.maxHealth * (player.regen || 0));
      }
    }
  };
  // CHANGE HEALTH:
  this.changeHealth = function (victim, dealer, dmg,  allowTeamDamage, crit) {
    if (
      (!game.waitTimers || game.waitTimers[0].canDMG) &&
      (!(dmg < 0) || victim.health != victim.maxHealth)
    ) {
      let V = Date.now();
      if (dealer && dealer.account && dealer.account.hack && dmg) {
        dmg *= 0;
      }
      if (dealer && dealer.noDmg) {
        dmg *= 0;
      }
      if (dealer && dealer.isHacker) {
        dmg *= 0;
      }
      if (dealer && dealer.hack) {
        if (dealer.hack.check.force) {
          dmg = 0;
        } else if (dealer.hack.rot.log.filter((W) => W.flag).length > 2) {
          let W = V - dealer.hack.check.time;
          if (W < dealer.hack.dmgMlt.delay) {
            if (W < 500) {
              dmg *= dealer.hack.dmgMlt.val;
            }
            dealer.hack.dmgMlt.val *= 0.5;
          }
        }
      }
      if (
        !!allowTeamDamage ||
        !!game.mode.dmgTeam ||
        !victim.team ||
        !dealer ||
        victim.team != dealer.team ||
        !(dmg > 0)
      ) {
        if (dealer && dealer.team) {
          if (dealer.team == 1) {
            dmg *= game.config.t1Dmg || 0;
          } else if (dealer.team == 2) {
            dmg *= game.config.t2Dmg || 0;
          }
        }
        if (dealer && dealer != victim && dmg > 0) {
          IO.send(dealer.id, "4", victim.sid, Math.round(dmg), crit, !!(victim.health - dmg <= 0));
        }
        if (victim.dummy) {
          return true;
        }
        if (dmg > 0) {
          victim.hitTimer = victim.regenDelay || 0;
        }
        victim.health -= dmg;
        victim.health = Math.max(Math.min(victim.maxHealth, victim.health), 0);
        if (victim.godMode) {
          victim.health = victim.maxHealth;
        }
        if (dealer) {
          IO.send(
            victim.id,
            "h",
            Math.ceil(victim.health),
            null,
            Math.round(dealer.x),
            Math.round(dealer.z),
          );
          if (dealer != victim) {
            dealer.dmgDealt += dmg;
            if (victim.dmgReceived[dealer.id]) {
              victim.dmgReceived[dealer.id].val += dmg;
              victim.dmgReceived[dealer.id].time = game.now;
            } else {
              victim.dmgReceived[dealer.id] = {
                time: game.now,
                val: dmg,
              };
            }
          }
        } else {
          IO.send(victim.id, "h", Math.ceil(victim.health));
        }
        for (var U = 0; U < this.list.length; ++U) {
          if (this.list[U] != victim) {
            IO.send(this.list[U].id, "h", Math.ceil(victim.health), victim.sid);
          }
          if (dealer && dealer != victim && dmg > 0 && this.list[U].specStream == dealer.sid) {
            IO.send(this.list[U].id, "4", victim.sid, Math.round(dmg), crit);
          }
        }
        return victim.health <= 0;
      }
    }
  };
  this.changePosition = function (player, Q, R, S, T, U, V) {
    player.oldX = Q;
    player.oldY = R;
    player.oldZ = S;
    player.x = Q;
    player.y = R;
    player.z = S;
    if (V != null) {
      player.yaw = (-((V || 0) + 1) * Math.PI) / 2;
      if (player.isYou) {
        game.controls.object.rotation.y = player.yaw;
        game.controls.xDr = game.controls.object.rotation.y % Math.PI2;
      }
    }
    if (U) {
      player.lastX = Q;
      player.lastY = R;
      player.lastZ = S;
      player.stepVal = 0;
      player.velX = 0;
      player.velY = 0;
      player.velZ = 0;
    }
    if (T) {
      player.doRecon = true;
    }
  };
  // SWAP SECONDARY:
  this.swapSecondary = function (player, Q) {
    if (!(player.ammos.length <= 1)) {
      var R;
      for (var S = 0; S < player.ammos.length; ++S) {
        R = player.loadout[S];
        if (game.weaponConfig[R] && game.weaponConfig[R].secondary) {
          if (player.weaponIndex == S) {
            this.reload(player, null, null, undefined, 0, Q);
          } else {
            this.reload(player, null, null, undefined, S, Q);
          }
        }
      }
    }
  };
  this.swapEquipment = function (player, Q) {
    if (!(player.ammos.length <= 1)) {
      var R;
      for (var S = 0; S < player.ammos.length; ++S) {
        R = player.loadout[S];
        if (game.weaponConfig[R] && game.weaponConfig[R].equipment) {
          if (player.weaponIndex == S) {
            this.reload(player, null, null, undefined, 0, Q);
          } else {
            this.reload(player, null, null, undefined, S, Q);
          }
        }
      }
    }
  };
  // SWAP MELEE:
  this.swapMelee = function (player, Q) {
    if (!(player.ammos.length <= 1)) {
      var R;
      for (var S = 0; S < player.ammos.length; ++S) {
        R = player.loadout[S];
        if (game.weaponConfig[R] && game.weaponConfig[R].melee) {
          if (player.weaponIndex == S) {
            this.reload(player, 1, false, undefined, undefined, Q);
          } else {
            this.reload(player, null, null, undefined, S, Q);
          }
        }
      }
    }
  };
  // RELOAD:
  this.reload = function (player, Q, R, S, T, U) {
    if ((!(player.ammos.length <= 1) || !Q) && !(S > player.ammos.length)) {
      var V = player.weaponIndex;
      if (Q) {
        if (Q != 1 && Q != -1) {
          Q = 0;
        }
        player.weaponIndex += Q;
        if (Q == 1) {
          if (
            player.weaponIndex >
            player.ammos.length - (player.ammos.length > 3 ? 3 : 2)
          ) {
            player.weaponIndex = 0;
          }
        } else if (player.weaponIndex < 0) {
          player.weaponIndex = Math.min(player.ammos.length - 1, 2);
        } else {
          player.weaponIndex = 0;
        }
      }
      if (S != null) {
        player.weaponIndex = S;
      }
      if (T != null) {
        player.weaponIndex = T;
      }
      if ((Q != null || T != null) && (V != player.weaponIndex || R)) {
        if (player.isYou) {
          this.resetReloadUIAnim();
        }
        player.reloadTimer = 0;
        player.didShoot = false;
        player.burstCount = 0;
      }
      player.weapon = game.weaponConfig[player.loadout[player.weaponIndex]];
      if (!player.weapon) {
        player.weapon = game.weaponConfig[player.loadout[0]];
        if (player.weapon) {
          player.weaponIndex = 0;
        }
      }
      if (RENDER && (V != player.weaponIndex || R)) {
        this.cancelInspect(player);
        for (var W = 0; W < player.weaponMeshes.length; ++W) {
          player.weaponMeshes[W].visible = false;
        }
        if (player.weaponMeshes[player.weaponIndex]) {
          player.weaponMeshes[player.weaponIndex].visible =
            !this.isWeaponHidden(player, player.weaponIndex) ||
            !player.renderYou;
          if (player.weapon.melee) {
            if (player.armMeshes[0]) {
              player.armMeshes[0].visible = RENDER.showHands;
            }
            if (player.armMeshes[1]) {
              if (!player.armMeshes[1].realMat) {
                player.armMeshes[1].realMat = player.armMeshes[1].material;
              }
              player.armMeshes[1].material = RENDER.showHands
                ? player.armMeshes[1].realMat
                : RENDER.invisMat;
            }
          } else if (player.weapon.akimbo) {
            if (player.weaponMeshes[player.weaponIndex].children[4]) {
              player.weaponMeshes[player.weaponIndex].children[4].visible =
                RENDER.showHands;
            }
          } else if (player.weaponMeshes[player.weaponIndex].children[2]) {
            player.weaponMeshes[player.weaponIndex].children[2].visible =
              RENDER.showHands;
          }
        }
      }
      if (
        S == null &&
        player.weapon &&
        (!RENDER || player.isYou) &&
        ((player.isYou && V == player.weaponIndex && !R) ||
          U ||
          (player.swapTime = player.weapon.swapTime),
        player.isYou && (V != player.weaponIndex || R))
      ) {
        var X;
        var Y = "";
        var Z =
          player.loadout.toString() === player.lastLoadout.toString() &&
          weapDisplay.innerHTML.length;
        for (W = 0; W < player.ammos.length; ++W) {
          X = W == player.weaponIndex;
          if (game.weaponConfig[player.loadout[W]].icon) {
            if (Z) {
              var a0 = document.getElementById("weapItem_" + W);
              if (a0.lastChild.style.opacity != (X ? 1 : 0.7)) {
                a0.lastChild.style.opacity = X ? 1 : 0.7;
              }
              if (a0.lastChild.style.marginRight != (W ? "25px" : "")) {
                a0.lastChild.style.marginRight = W ? "25px" : "";
              }
              if (player.lastThrow != player.canThrow) {
                a0.lastChild.src = UTILS.assetsUrl(
                  (player.canThrow && game.weaponConfig[player.loadout[W]].melee
                    ? "/textures/melee/icon_" +
                      ((game.store.skins[player.meleeIndex] &&
                        game.store.skins[player.meleeIndex].id) ||
                        0)
                    : "/textures/weapons/" +
                      game.weaponConfig[player.loadout[W]].icon) + ".png",
                );
              }
              if (W > 0) {
                a0.firstChild.textContent = game.weaponConfig[player.loadout[W]]
                  .melee
                  ? "[" +
                    UTILS.getKeyName(game.controls.binds.meleeKey.val) +
                    "]"
                  : game.weaponConfig[player.loadout[W]].equipment
                    ? "[" +
                      UTILS.getKeyName(game.controls.binds.equipKey.val) +
                      "]"
                    : "[" +
                      UTILS.getKeyName(game.controls.binds.swapKey.val) +
                      "]";
              }
            } else {
              Y +=
                "<div class='weapItem' id='weapItem_" +
                W +
                "'>" +
                (W > 0
                  ? "<div class='weapKey'>" +
                    (game.weaponConfig[player.loadout[W]].melee
                      ? "[" +
                        UTILS.getKeyName(game.controls.binds.meleeKey.val) +
                        "]"
                      : game.weaponConfig[player.loadout[W]].equipment
                        ? "[" +
                          UTILS.getKeyName(game.controls.binds.equipKey.val) +
                          "]"
                        : "[" +
                          UTILS.getKeyName(game.controls.binds.swapKey.val) +
                          "]") +
                    "</div>"
                  : "") +
                "<img style='opacity:" +
                (X ? 1 : 0.7) +
                (W ? ";margin-right:25px" : "") +
                "' class='weapIcon' src='" +
                UTILS.assetsUrl(
                  (player.canThrow && game.weaponConfig[player.loadout[W]].melee
                    ? "/textures/melee/icon_" +
                      ((game.store.skins[player.meleeIndex] &&
                        game.store.skins[player.meleeIndex].id) ||
                        0)
                    : "/textures/weapons/" +
                      game.weaponConfig[player.loadout[W]].icon) + ".png",
                ) +
                "' " +
                (game.weaponConfig[player.loadout[W]].melee
                  ? "id='weapIconMel' "
                  : "") +
                "/></div>";
            }
          }
          if (game.weaponConfig[player.loadout[W]].melee) {
            player.lastThrow = player.canThrow;
          }
        }
        if (!U) {
          if (player.swapTween) {
            player.swapTween.stop();
          }
          player.swapTweenA = 0.5;
          player.swapTween = new TWEEN.Tween(player)
            .to(
              {
                swapTweenA: 1,
              },
              1200,
            )
            .easing(TWEEN.Easing.Elastic.Out)
            .start();
          if (V != player.weaponIndex && player.aimVal == 1) {
            if (player.swapTweenAnim) {
              player.swapTweenAnim.stop();
            }
            player.swapTweenR = player.weapon.swapWiggle || 0.6;
            player.swapTweenAnim = new TWEEN.Tween(player)
              .to(
                {
                  swapTweenR: 0,
                },
                player.weapon.swapTime + 220,
              )
              .easing(TWEEN.Easing.Back.InOut)
              .start();
          }
          if (V != player.weaponIndex) {
            if (player.meleeAnim.anim) {
              player.meleeAnim.anim.stop();
            }
            player.resetMeleeAnim();
            if (player.aimVal == 1) {
              player.meleeAnim.armR = -0.3;
              if (player.weapon.melee) {
                if (
                  game.store.skins[player.meleeIndex] &&
                  game.store.skins[player.meleeIndex].flipAnim
                ) {
                  player.meleeAnim.weaR = Math.PI * -4;
                }
                if (player.canThrow) {
                  SOUND.play("melee_equip", 0.06, false, 1.5);
                }
                player.meleeAnim.anim = new TWEEN.Tween(player.meleeAnim)
                  .to(
                    {
                      armR: 0,
                      weaR: 0,
                    },
                    310,
                  )
                  .easing(TWEEN.Easing.Sinusoidal.Out)
                  .start();
              }
            }
          }
        }
        if (!Z) {
          weapDisplay.innerHTML = Y;
        }
        player.lastLoadout = [...player.loadout];
        this.updatePlayerAmmo(player);
      }
    }
  };
  this.taunt = function (player, Q) {
    if (
      player &&
      player.active &&
      config.taunts[Q] &&
      (!player.lastTaunt || game.now - player.lastTaunt >= 0)
    ) {
      player.lastTaunt = game.now + config.taunts[Q].tm;
      game.playSound(
        config.taunts[Q].id,
        0.3,
        player.sid,
        player.x,
        player.y,
        player.z,
        true,
        UTILS.randFloat(0.9, 1),
      );
    }
  };
    this.swapWeapon = function (player, Q, R, S, T, U) {
    if ((!(player.ammos.length <= 1) || !Q) && !(S > player.ammos.length)) {
      var V = player.weaponIndex;
      if (Q) {
        if (Q != 1 && Q != -1) {
          Q = 0;
        }
        player.weaponIndex += Q;
        if (Q == 1) {
          if (player.weaponIndex > player.ammos.length - (player.ammos.length > 3 ? 3 : 2)) {
            player.weaponIndex = 0;
          }
        } else if (player.weaponIndex < 0) {
          player.weaponIndex = Math.min(player.ammos.length - 1, 2);
        } else {
          player.weaponIndex = 0;
        }
      }
      if (S != null) {
        player.weaponIndex = S;
      }
      if (T != null) {
        player.weaponIndex = T;
      }
      if ((Q != null || T != null) && (V != player.weaponIndex || R)) {
        if (player.isYou) {
          this.resetReloadUIAnim();
        }
        player.reloadTimer = 0;
        player.didShoot = false;
        player.burstCount = 0;
      }
      player.weapon = game.weaponConfig[player.loadout[player.weaponIndex]];
      if (!player.weapon) {
        player.weapon = game.weaponConfig[player.loadout[0]];
        if (player.weapon) {
          player.weaponIndex = 0;
        }
      }
      if (RENDER && (V != player.weaponIndex || R)) {
        this.cancelInspect(player);
        for (var W = 0; W < player.weaponMeshes.length; ++W) {
          player.weaponMeshes[W].visible = false;
        }
        if (player.weaponMeshes[player.weaponIndex]) {
          player.weaponMeshes[player.weaponIndex].visible = !this.isWeaponHidden(player, player.weaponIndex) || !player.renderYou;
          if (player.weapon.melee) {
            if (player.armMeshes[0]) {
              player.armMeshes[0].visible = RENDER.showHands;
            }
            if (player.armMeshes[1]) {
              if (!player.armMeshes[1].realMat) {
                player.armMeshes[1].realMat = player.armMeshes[1].material;
              }
              player.armMeshes[1].material = RENDER.showHands ? player.armMeshes[1].realMat : RENDER.invisMat;
            }
          } else if (player.weapon.akimbo) {
            if (player.weaponMeshes[player.weaponIndex].children[4]) {
              player.weaponMeshes[player.weaponIndex].children[4].visible = RENDER.showHands;
            }
          } else if (player.weaponMeshes[player.weaponIndex].children[2]) {
            player.weaponMeshes[player.weaponIndex].children[2].visible = RENDER.showHands;
          }
        }
      }
      if (S == null && player.weapon && (!RENDER || player.isYou) && (player.isYou && V == player.weaponIndex && !R || U || (player.swapTime = player.weapon.swapTime), player.isYou && (V != player.weaponIndex || R))) {
        var X;
        var Y = "";
        var Z = player.loadout.toString() === player.lastLoadout.toString() && weapDisplay.innerHTML.length;
        for (W = 0; W < player.ammos.length; ++W) {
          X = W == player.weaponIndex;
          if (game.weaponConfig[player.loadout[W]].icon) {
            if (Z) {
              var a0 = document.getElementById("weapItem_" + W);
              if (a0.lastChild.style.opacity != (X ? 1 : 0.7)) {
                a0.lastChild.style.opacity = X ? 1 : 0.7;
              }
              if (a0.lastChild.style.marginRight != (W ? "25px" : "")) {
                a0.lastChild.style.marginRight = W ? "25px" : "";
              }
              if (player.lastThrow != player.canThrow) {
                a0.lastChild.src = UTILS.assetsUrl((player.canThrow && game.weaponConfig[player.loadout[W]].melee ? "/textures/melee/icon_" + (game.store.skins[player.meleeIndex] && game.store.skins[player.meleeIndex].id || 0) : "/textures/weapons/" + game.weaponConfig[player.loadout[W]].icon) + ".png");
              }
              if (W > 0) {
                a0.firstChild.textContent = game.weaponConfig[player.loadout[W]].melee ? "[" + UTILS.getKeyName(game.controls.binds.meleeKey.val) + "]" : game.weaponConfig[player.loadout[W]].equipment ? "[" + UTILS.getKeyName(game.controls.binds.equipKey.val) + "]" : "[" + UTILS.getKeyName(game.controls.binds.swapKey.val) + "]";
              }
            } else {
              Y += "<div class='weapItem' id='weapItem_" + W + "'>" + (W > 0 ? "<div class='weapKey'>" + (game.weaponConfig[player.loadout[W]].melee ? "[" + UTILS.getKeyName(game.controls.binds.meleeKey.val) + "]" : game.weaponConfig[player.loadout[W]].equipment ? "[" + UTILS.getKeyName(game.controls.binds.equipKey.val) + "]" : "[" + UTILS.getKeyName(game.controls.binds.swapKey.val) + "]") + "</div>" : "") + "<img style='opacity:" + (X ? 1 : 0.7) + (W ? ";margin-right:25px" : "") + "' class='weapIcon' src='" + UTILS.assetsUrl((player.canThrow && game.weaponConfig[player.loadout[W]].melee ? "/textures/melee/icon_" + (game.store.skins[player.meleeIndex] && game.store.skins[player.meleeIndex].id || 0) : "/textures/weapons/" + game.weaponConfig[player.loadout[W]].icon) + ".png") + "' " + (game.weaponConfig[player.loadout[W]].melee ? "id='weapIconMel' " : "") + "/></div>";
            }
          }
          if (game.weaponConfig[player.loadout[W]].melee) {
            player.lastThrow = player.canThrow;
          }
        }
        if (!U) {
          if (player.swapTween) {
            player.swapTween.stop();
          }
          player.swapTweenA = 0.5;
          player.swapTween = new TWEEN.Tween(player).to({
            swapTweenA: 1
          }, 1200).easing(TWEEN.Easing.Elastic.Out).start();
          if (V != player.weaponIndex && player.aimVal == 1) {
            if (player.swapTweenAnim) {
              player.swapTweenAnim.stop();
            }
            player.swapTweenR = player.weapon.swapWiggle || 0.6;
            player.swapTweenAnim = new TWEEN.Tween(player).to({
              swapTweenR: 0
            }, player.weapon.swapTime + 220).easing(TWEEN.Easing.Back.InOut).start();
          }
          if (V != player.weaponIndex) {
            if (player.meleeAnim.anim) {
              player.meleeAnim.anim.stop();
            }
            player.resetMeleeAnim();
            if (player.aimVal == 1) {
              player.meleeAnim.armR = -0.3;
              if (player.weapon.melee) {
                if (game.store.skins[player.meleeIndex] && game.store.skins[player.meleeIndex].flipAnim) {
                  player.meleeAnim.weaR = Math.PI * -4;
                }
                if (player.canThrow) {
                  SOUND.play("melee_equip", 0.06, false, 1.5);
                }
                player.meleeAnim.anim = new TWEEN.Tween(player.meleeAnim).to({
                  armR: 0,
                  weaR: 0
                }, 310).easing(TWEEN.Easing.Sinusoidal.Out).start();
              }
            }
          }
        }
        if (!Z) {
          weapDisplay.innerHTML = Y;
        }
        player.lastLoadout = [...player.loadout];
        this.updatePlayerAmmo(player);
      }
    }
  };
  // REMOVE STREAK:
  this.useStreak = function (player, Q) {
    if (player.streaks[Q] && player.streaks[Q].streak.activate(game, player)) {
      if (player.streaks[Q].cnt > 1) {
        player.streaks[Q].cnt--;
      } else {
        player.streaks[Q] = null;
      }
      IO.send(player.id, "st", Q, (player.streaks[Q] && player.streaks[Q].cnt) || 0);
    }
  };
  // CHECK KILL STREAK:
  this.checkStreak = function (player) {
    for (var Q = 0; Q < game.streaks.length; ++Q) {
      if (player.realKillStreak == game.streaks[Q].kills) {
        this.addStreak(player, Q);
      }
    }
    if (player.realKillStreak >= game.maxStreak) {
      player.realKillStreak = 0;
    }
  };
  // ADD STREAK TO PLAYER:
  this.addStreak = function (player, Q) {
    if (player.streaks[Q]) {
      player.streaks[Q].cnt++;
    } else {
      player.streaks[Q] = {
        cnt: 1,
        streak: game.streaks[Q],
      };
    }
    IO.send(player.id, "st", Q, player.streaks[Q].cnt);
  };
  // KILL PLAYER:
  this.kill = function (player, Q, R, S, T) {
    if (player.dummy || player.active) {
      if (game && game.mode && game.mode.noKillFeed) {
        S = true;
      }
      var U = false;
      var V = -1;
      if (!player.dummy) {
        player.active = false;
        if (player.isYou) {
          this.toggleAim(player, 0);
        }
        if (player.objInstances) {
          this.disposeMesh(player);
        }
      }
      if (IO) {
        var W;
        var X = 0;
        var Y = R && R.stk != null;
        player.deaths++;
        if (game && !game.isCustom && Q && Q.killCheck) {
          Q.killCheck();
        }
        if (
          !game.mode.noClan &&
          !!player.account &&
          player.account.clanCon == 1 &&
          game.host == null &&
          (!Q ||
            Q == player ||
            (!!player.account &&
              (!Q ||
                !Q.account ||
                !player.account ||
                Q.account.clan != player.account.clan)))
        ) {
          player.clanDeathsP++;
          player.account.clanDeaths++;
        }
        player.lastKiller = null;
        player.deathInfo.doer = Q;
        player.deathInfo.time = game.now;
        player.deathInfo.tillNext = game.forceSpawn
          ? game.forceSpawn * 1000 + config.deathDelay
          : null;
        if (!game.mode.noStreaks && !game.config.noStreaks) {
          player.deathStreak++;
        }
        if (player.lives && !game.waitTimers) {
          player.lives--;
          IO.send(player.id, "lv", player.lives);
        }
        game.kills++;
        if (Q) {
          V = R.wId == null ? Q.loadout[Q.weaponIndex] : R.wId;
        }
        if (Q && Q != player) {
          player.lastKiller = Q.id;
          if (!player.dummy) {
            Q.kills++;
            if (
              !game.mode.noClan &&
              Q.account &&
              Q.account.clanCon == 1 &&
              Q.account.clanDeaths < config.clanWarLives &&
              (!player.account || (player.account && Q.account.clan != player.account.clan)) &&
              player.spinDis > 0.1 &&
              player.coverDis >= 10 &&
              (!IO.sockets[player.id] ||
                !IO.sockets[Q.id] ||
                IO.sockets[player.id].remoteAddress !=
                  IO.sockets[Q.id].remoteAddress)
            ) {
              Q.clanKillsP++;
            }
            if (!player.account && player.kills == 0) {
              Q.sussKills++;
            }
            if (!Y) {
              if (Q.weaponKills[V]) {
                Q.weaponKills[V]++;
              } else {
                Q.weaponKills[V] = 1;
              }
            }
          }
          if (!game.mode.noStreaks && !game.config.noStreaks) {
            Q.streak++;
            Q.killStreak++;
            Q.realKillStreak++;
            if (Q.killStreak > Q.highestStreak) {
              Q.highestStreak = Q.killStreak;
            }
            if (!Y) {
              if (Q.currentStreakWeapon != null && Q.currentStreakWeapon != V) {
                Q.weaponStreak = 1;
              } else {
                Q.weaponStreak++;
              }
              Q.currentStreakWeapon = V;
              if (
                Q.weaponStreak >
                (Q.highestWeaponStreak[Q.currentStreakWeapon] || 0)
              ) {
                Q.highestWeaponStreak[Q.currentStreakWeapon] = Q.weaponStreak;
              }
            }
            Q.deathStreak = 0;
            this.checkStreak(Q);
            if (Q.killStreak % 5 == 0) {
              X = Q.killStreak;
            }
            if (game.now - Q.lastKill >= config.feedTimer) {
              Q.streak = 0;
            }
          }
          Q.lastKill = game.now;
          if (!T && game.config.killRewards && !game.mode.noKillRewards) {
            if ((W = J.reward(this, Q, player, R, game, UTILS))) {
              IO.send(
                Q.id,
                "6",
                W,
                config.networkSounds.indexOf(this.getKillSnd(R, Q)),
                Q.kills,
              );
            }
            this.score(Q, J.getScore(W), true);
            U = true;
          }
          game.players.dropWeapon(player, true);
          if (V == 12 && Q.account && !Y) {
            game.doVirus(player, Q);
          }
        }
        if (R && R.w) {
          delete R.w;
        }
        if (!player.dummy) {
          for (var Z = 0; Z < this.list.length; ++Z) {
            if (
              !game.mode.noAssists &&
              player.dmgReceived[this.list[Z].id] &&
              Q != this.list[Z] &&
              player.dmgReceived[this.list[Z].id].val >= config.assistMin &&
              game.now - player.dmgReceived[this.list[Z].id].time <=
                config.assistTime
            ) {
              this.list[Z].assists++;
              this.score(this.list[Z], config.assistScore, true);
              IO.send(this.list[Z].id, "10");
              U = true;
            }
            if (this.list[Z] == player) {
              IO.send(
                player.id,
                "3",
                player.sid,
                player.deaths,
                Q ? Q.sid : 0,
                [
                  V,
                  W ? J.getScore(W) : 0,
                  Q && Q.account && Q.account.stats["c" + Q.classIndex]
                    ? Q.account.stats["c" + Q.classIndex]
                    : 0,
                  Q && Q.account && Q.kcStatIndex != -1
                    ? [
                        config.killCardStats[Q.kcStatIndex].name,
                        config.killCardStats[Q.kcStatIndex].stat(Q),
                      ]
                    : null,
                ],
                R,
                S,
              );
            } else {
              IO.send(
                this.list[Z].id,
                "3",
                player.sid,
                player.deaths,
                Q ? Q.sid : 0,
                null,
                R,
                S,
              );
            }
          }
        }
        if (game.mode.onKill) {
          game.mode.onKill(game, IO, player, Q, R);
        }
        if (X) {
          // KST PACKET
          window.IO.broadcast("game" + game.sid, "kst", Q.sid, X);
        }
      }
      if (IO && !U) {
        this.syncLeaders();
      }
    }
  };
  this.getKillSnd = function (P, Q) {
    if (P.hs) {
      return "headshot_0";
    }
    if (P.wId == null) {
      return null;
    }
    var R;
    var S = Q.loadout.indexOf(P.wId);
    if (
      (R =
        P.wId == 12
          ? game.store.skins[Q.meleeIndex || null] || null
          : game.store.skins[Q.skins[S] || null] || null) &&
      R.snd &&
      R.type
    ) {
      return P.w.sound + (R && R.id != null ? "_" + R.id : "");
    } else {
      return null;
    }
  };
  this.findNearestTo = function (P, Q, R, S, T) {
    var U = null;
    for (var V = 0; V < this.list.length; ++V) {
      if (this.list[V].active) {
        var W = UTILS.getD3D(
          P,
          Q,
          R,
          this.list[V].x,
          this.list[V].y,
          this.list[V].z,
        );
        if (
          W <= S &&
          (!U || U.ds > W) &&
          (T || !game.canSee(this.list[V], P, Q, R, 0, 0, true))
        ) {
          U = {
            obj: this.list[V],
            ds: W,
          };
        }
      }
    }
    if (U) {
      return U.obj;
    } else {
      return null;
    }
  };
  // FIND BY SID:
  this.findBySid = function (P) {
    for (var Q = 0; Q < this.list.length; ++Q) {
      if (this.list[Q].sid === P) {
        return this.list[Q];
      }
    }
    return null;
  };
  this.findById = function (P) {
    for (var Q = 0; Q < this.list.length; ++Q) {
      if (this.list[Q].id === P) {
        return this.list[Q];
      }
    }
    return null;
  };
  // INDEX BY SID:
  this.indexBySid = function (P) {
    for (var Q = 0; Q < this.list.length; ++Q) {
      if (this.list[Q].sid == P) {
        return Q;
      }
    }
    return -1;
  };
};
